/** Generate by swagger-axios-codegen */
// tslint:disable
/* eslint-disable */
import axiosStatic, { AxiosInstance } from 'axios';

export interface IRequestOptions {
  headers?: any;
  baseURL?: string;
  responseType?: string;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export class IList<T> extends Array<T> {}
export class List<T> extends Array<T> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount: number;
}

export class PagedResultDto<T> implements IPagedResult<T> {
  totalCount!: number;
}

// customer definition
// empty

export class AccountService {
  /**
   *
   */
  static isTenantAvailable(
    params: {
      /** requestBody */
      body?: IsTenantAvailableInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IsTenantAvailableOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Account/IsTenantAvailable';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static register(
    params: {
      /** requestBody */
      body?: RegisterInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RegisterOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Account/Register';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ActivityService {
  /**
   *
   */
  static getAll(
    params: {
      /** all | notStarted(活动未开始) | started(进行中) | finished(已结束) */
      filterType?: string;
      /** 活动标题 */
      title?: string;
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FilterType: params['filterType'],
        Title: params['title'],
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createFilterForAuditLog(options: IRequestOptions = {}): Promise<ActivityAuditLogItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/CreateFilterForAuditLog';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 创建活动
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditActivityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditActivityDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取活动单条记录
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 管理后台修改活动审核状态
   */
  static changeStatus(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/ChangeStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新活动
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditActivityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 活动删除
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 用户对活动的收藏,分享事件
   */
  static postEvent(
    params: {
      /** requestBody */
      body?: Int32EntityEventDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/PostEvent';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取用户与活动的参与状态
   */
  static getUserActivityApplyStatus(
    params: {
      /**  */
      activityId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserActivityApplyStatus> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/GetUserActivityApplyStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { activityId: params['activityId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static pay(
    params: {
      /** requestBody */
      body?: CreateOrEditActivityApplyDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WxPayResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Pay';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static rePay(
    params: {
      /** requestBody */
      body?: ApplyRepayInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WxPayResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/RePay';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 用户发起退款
   */
  static refund(
    params: {
      /**  */
      totalPrice?: number;
      /**  */
      desc: string;
      /**  */
      auditFlowId: string;
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Refund';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        TotalPrice: params['totalPrice'],
        Desc: params['desc'],
        AuditFlowId: params['auditFlowId'],
        Id: params['id']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static startAudit(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/StartAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取得当前登录用户能审核的所有机构的项目
   */
  static getMyAll(
    params: {
      /** all | notStarted(活动未开始) | started(进行中) | finished(已结束) */
      filterType?: string;
      /** 活动标题 */
      title?: string;
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        FilterType: params['filterType'],
        Title: params['title'],
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAuditLogs(
    params: {
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityDtoAuditUserLogDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/GetMyAuditLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { SkipCount: params['skipCount'], MaxResultCount: params['maxResultCount'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Activity/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ActivityApplyService {
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 门店取得报名信息
   */
  static getAll(
    params: {
      /**  */
      activityId?: number;
      /**  */
      title?: string;
      /** 是否只获取当前用户的报名信息 */
      onlyApplier?: boolean;
      /**  */
      status?: ActivityApplyStatus;
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ActivityId: params['activityId'],
        Title: params['title'],
        OnlyApplier: params['onlyApplier'],
        Status: params['status'],
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取得用户的全部活动报名[带分页]
   */
  static getUserApply(
    params: {
      /**  */
      activityId?: number;
      /**  */
      title?: string;
      /** 是否只获取当前用户的报名信息 */
      onlyApplier?: boolean;
      /**  */
      status?: ActivityApplyStatus;
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetUserApply';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ActivityId: params['activityId'],
        Title: params['title'],
        OnlyApplier: params['onlyApplier'],
        Status: params['status'],
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取我的单条订单详情
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 用户取消报名
   */
  static userCancel(
    params: {
      /** requestBody */
      body?: EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/UserCancel';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 签到
   */
  static checkOut(
    params: {
      /** requestBody */
      body?: EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/CheckOut';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static checkOutLocation(
    params: {
      /**  */
      applyId?: number;
      /**  */
      lat?: number;
      /**  */
      lng?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/CheckOutLocation';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { applyId: params['applyId'], lat: params['lat'], lng: params['lng'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 机构核销
   */
  static ouCheckOut(
    params: {
      /** requestBody */
      body?: EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/OUCheckOut';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 签到页获取当前用户单条报名信息
   */
  static getQdApply(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ActivityApply/GetQdApply';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class AttachmentService {
  /**
   *
   */
  static getAttachments(
    params: {
      /**  */
      hostId?: string;
      /**  */
      hostType?: AttachmentHostType;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AttachmentDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Attachment/GetAttachments';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { hostId: params['hostId'], hostType: params['hostType'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 上传到临时目录
   */
  static uploadToTemp(options: IRequestOptions = {}): Promise<UploadResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Attachment/UploadToTemp';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 上传到oss
   */
  static uploadToOss(options: IRequestOptions = {}): Promise<UploadResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Attachment/UploadToOss';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载附件
   */
  static download(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Attachment/Download';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class AuditFlowService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditAuditFlowDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditAuditFlowDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditAuditFlowDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditFlowDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditFlow/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class AuditLogService {
  /**
   *
   */
  static getAuditLogs(
    params: {
      /**  */
      startDate?: string;
      /**  */
      endDate?: string;
      /**  */
      userName?: string;
      /**  */
      serviceName?: string;
      /**  */
      methodName?: string;
      /**  */
      browserInfo?: string;
      /**  */
      hasException?: boolean;
      /**  */
      minExecutionDuration?: number;
      /**  */
      maxExecutionDuration?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
      /**  */
      skipCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditLogListDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditLog/GetAuditLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        UserName: params['userName'],
        ServiceName: params['serviceName'],
        MethodName: params['methodName'],
        BrowserInfo: params['browserInfo'],
        HasException: params['hasException'],
        MinExecutionDuration: params['minExecutionDuration'],
        MaxExecutionDuration: params['maxExecutionDuration'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount'],
        SkipCount: params['skipCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getEntityPropertyChanges(
    params: {
      /**  */
      entityChangeId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EntityPropertyChangeDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditLog/GetEntityPropertyChanges';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { entityChangeId: params['entityChangeId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class AuditNodePreDefineService {
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditAuditNodePreDefineDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditNodePreDefineDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditNodePreDefineDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditAuditNodePreDefineDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditNodePreDefineDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditAuditNodePreDefineDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditNodePreDefineDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/AuditNodePreDefine/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class BaseCardService {
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditCardDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BaseCard/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CardDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BaseCard/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CardDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BaseCard/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditCardDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BaseCard/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditCardDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BaseCard/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BaseCard/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCardSkuForEdit(
    params: {
      /** 标题 */
      title?: string;
      /** 状态 */
      status?: number;
      /** 会员卡 */
      cardId?: number;
      /** 原价 */
      originPrice?: number;
      /** 售价 */
      price?: number;
      /** 简介 */
      desc?: string;
      /** 持续时间 */
      durationMonth?: number;
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditCardSkuDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BaseCard/GetCardSkuForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        Status: params['status'],
        CardId: params['cardId'],
        OriginPrice: params['originPrice'],
        Price: params['price'],
        Desc: params['desc'],
        DurationMonth: params['durationMonth'],
        Id: params['id']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static syncCard(
    params: {
      /** requestBody */
      body?: EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/BaseCard/SyncCard';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CardService {
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditCardDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Card/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      organizationUnitId?: number;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CardDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Card/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        OrganizationUnitId: params['organizationUnitId'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取所有由总部创建的基础会员卡
   */
  static getAllBaseCard(options: IRequestOptions = {}): Promise<CardDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Card/GetAllBaseCard';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Card/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CardDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Card/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * GetAllCardWithCoupon(获取所有我的会员卡和卡券)
   */
  static getAllCardWithCoupon(options: IRequestOptions = {}): Promise<CardWithCouponDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Card/GetAllCardWithCoupon';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * GetAllByBuyUserId
   */
  static getAllByBuyUserId(
    params: {
      /** 用户Id */
      userId?: number;
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserHoldCardInfoDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Card/GetAllByBuyUserId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        UserId: params['userId'],
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 购买会员卡支付
   */
  static getPay(
    params: {
      /** requestBody */
      body?: Int32PayWithCouponInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WxPayResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Card/GetPay';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditCardDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CardDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Card/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditCardDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CardDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Card/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CardReportDetailService {
  /**
   * 数据重置，强制重新加载
   */
  static resetData(
    params: {
      /** requestBody */
      body?: CardDetailReportInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CardReportDetail/ResetData';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      organizationId?: number;
      /**  */
      year: number;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CardDetailReportItemDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CardReportDetail/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrganizationId: params['organizationId'],
        Year: params['year'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CardSkuService {
  /**
   *
   */
  static getForEdit(
    params: {
      /** 标题 */
      title?: string;
      /** 状态 */
      status?: number;
      /** 会员卡 */
      cardId?: number;
      /** 原价 */
      originPrice?: number;
      /** 售价 */
      price?: number;
      /** 简介 */
      desc?: string;
      /** 持续时间 */
      durationMonth?: number;
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditCardSkuDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CardSku/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        Status: params['status'],
        CardId: params['cardId'],
        OriginPrice: params['originPrice'],
        Price: params['price'],
        Desc: params['desc'],
        DurationMonth: params['durationMonth'],
        Id: params['id']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CardSkuDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CardSku/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CardSkuDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CardSku/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditCardSkuDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CardSkuDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CardSku/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditCardSkuDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CardSkuDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CardSku/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CardSku/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ClientService {
  /**
   * 客户端初始化API
   */
  static init(options: IRequestOptions = {}): Promise<IndexPageData> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/Init';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCities(options: IRequestOptions = {}): Promise<string[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetCities';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDistrict(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetDistrict';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取所有门店
   */
  static getStores(
    params: {
      /**  */
      latitude?: number;
      /**  */
      longitude?: number;
      /**  */
      keyword?: string;
      /**  */
      city?: string;
      /**  */
      district?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetStores';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        latitude: params['latitude'],
        longitude: params['longitude'],
        keyword: params['keyword'],
        city: params['city'],
        district: params['district']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 面门首页信息
   */
  static getPageIndexData(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetPageIndexData';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取当前登录用户信息
   */
  static getCurrentUser(options: IRequestOptions = {}): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetCurrentUser';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 判断用户的宝贝资料是否已完善
   */
  static isBabyProfilePerfect(options: IRequestOptions = {}): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/IsBabyProfilePerfect';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPlaceSuggestion(
    params: {
      /**  */
      query?: string;
      /**  */
      region?: string;
      /**  */
      type?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Place[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetPlaceSuggestion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { query: params['query'], region: params['region'], type: params['type'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取门店所有可用的会员卡种类
   */
  static getStoreCards(options: IRequestOptions = {}): Promise<CardDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetStoreCards';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新用户基本信信息
   */
  static updateUserProfile(
    params: {
      /** requestBody */
      body?: UserProfileInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/UpdateUserProfile';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新用户宝贝信息
   */
  static updateUserBabyDetail(
    params: {
      /** requestBody */
      body?: UserBabyDetailEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/UpdateUserBabyDetail';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 客户端获取我的信息
   */
  static getUserPageData(options: IRequestOptions = {}): Promise<UserPageData> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetUserPageData';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 生成用户的分享小程序码
   */
  static getUserShareQr(
    params: {
      /** AgileBoost.TongMeng.Entities.Users.UserSharedEventType */
      eventType?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetUserShareQr';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { eventType: params['eventType'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUnLimitQr(
    params: {
      /**  */
      scene?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetUnLimitQr';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { scene: params['scene'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 用户扫 分享码进入小程序回调
   */
  static sharedCallback(
    params: {
      /**  */
      scene?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/SharedCallback';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { scene: params['scene'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static scanCallback(
    params: {
      /** requestBody */
      body?: ScanInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<BoolMessage> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/ScanCallback';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static upload(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/Upload';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSignature(
    params: {
      /**  */
      data?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetSignature';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { data: params['data'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getActivityApplis(
    params: {
      /**  */
      activityId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityApplyBaseDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Client/GetActivityApplis';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { activityId: params['activityId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CmsCategoryService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByCategoryCode(
    params: {
      /**  */
      categoryCode: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/GetByCategoryCode';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { categoryCode: params['categoryCode'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sync(
    params: {
      /** requestBody */
      body?: EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/Sync';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CmsCategoryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CmsCategoryCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsCategoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsCategory/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CmsContentService {
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsContentDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      title?: string;
      /**  */
      categoryId?: number;
      /**  */
      status?: CmsContentStatus;
      /**  */
      copyFromViewType?: CopyFromViewType;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsContentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        CategoryId: params['categoryId'],
        Status: params['status'],
        CopyFromViewType: params['copyFromViewType'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取新闻单条记录
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsContentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 收藏/分享/点赞
   */
  static postEvent(
    params: {
      /** requestBody */
      body?: Int32EntityEventDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/PostEvent';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditCmsContentDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsContentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 发布文章
   */
  static publish(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Publish';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取消发布
   */
  static cancelPublish(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/CancelPublish';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static sync(
    params: {
      /** requestBody */
      body?: EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Sync';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditCmsContentDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CmsContentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CmsContent/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class CommonReserveFundAssignService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CommonReserveFundAssignDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CommonReserveFundAssign/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      year?: number;
      /**  */
      month?: number;
      /**  */
      name?: string;
      /**  */
      remark?: string;
      /**  */
      organizationUnitId?: number;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CommonReserveFundAssignDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CommonReserveFundAssign/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        Month: params['month'],
        Name: params['name'],
        Remark: params['remark'],
        OrganizationUnitId: params['organizationUnitId'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CommonReserveFundAssignDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CommonReserveFundAssign/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CommonReserveFundAssignCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CommonReserveFundAssignDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CommonReserveFundAssign/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CommonReserveFundAssignCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CommonReserveFundAssignDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CommonReserveFundAssign/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/CommonReserveFundAssign/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ConfigurationService {
  /**
   *
   */
  static changeUiTheme(
    params: {
      /** requestBody */
      body?: ChangeUiThemeInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Configuration/ChangeUiTheme';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取分账账单的平台接收人员(email list)
   */
  static getSplitOrderBillReceivers(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Configuration/GetSplitOrderBillReceivers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新分账账单的平台接收人员(email list)
   */
  static updateSplitOrderBillReceivers(
    params: {
      /** requestBody */
      body?: UpdateSplitOrderBillReceiversInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Configuration/UpdateSplitOrderBillReceivers';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取平台的微信微款账户
   */
  static getSplitOrderPlatformMchId(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Configuration/GetSplitOrderPlatformMchId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新平台的分账收款账户
   */
  static updateSplitOrderPlatformMchId(
    params: {
      /**  */
      mchId?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Configuration/UpdateSplitOrderPlatformMchId';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { mchId: params['mchId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取分账的周期设置
   */
  static getSplitOrderCycleSetting(options: IRequestOptions = {}): Promise<SplitOrderCycleSettingInput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Configuration/GetSplitOrderCycleSetting';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新分账的周期设置
   */
  static updateSplitOrderCycleSetting(
    params: {
      /** requestBody */
      body?: SplitOrderCycleSettingInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Configuration/UpdateSplitOrderCycleSetting';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取微信手续费比例
   */
  static getSplitBillWechatFeePercent(options: IRequestOptions = {}): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Configuration/GetSplitBillWechatFeePercent';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新微信手续费比例
   */
  static updateSplitBillWechatFeePercent(
    params: {
      /**  */
      wechatFeePercent?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Configuration/UpdateSplitBillWechatFeePercent';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { wechatFeePercent: params['wechatFeePercent'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class DataDictionariesService {
  /**
   * 分页查询
   */
  static getAll(
    params: {
      /**  */
      sorting?: string;
      /**  */
      isParent?: boolean;
      /** 键名 */
      key?: string;
      /** 显示的名称 */
      displayName?: string;
      /**  */
      parentId?: number;
      /** 备注 */
      remark?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionariesDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionaries/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Sorting: params['sorting'],
        IsParent: params['isParent'],
        Key: params['key'],
        DisplayName: params['displayName'],
        ParentId: params['parentId'],
        Remark: params['remark'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getListByParentId(
    params: {
      /**  */
      sorting?: string;
      /**  */
      isParent?: boolean;
      /** 键名 */
      key?: string;
      /** 显示的名称 */
      displayName?: string;
      /**  */
      parentId?: number;
      /** 备注 */
      remark?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionariesDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionaries/GetListByParentId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Sorting: params['sorting'],
        IsParent: params['isParent'],
        Key: params['key'],
        DisplayName: params['displayName'],
        ParentId: params['parentId'],
        Remark: params['remark'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionariesDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionaries/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: DataDictionariesCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionariesDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionaries/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: DataDictionariesCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DataDictionariesDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionaries/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/DataDictionaries/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class DepartmentService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DepartmentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Department/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditDepartmentDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Department/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditDepartmentDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DepartmentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Department/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DepartmentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Department/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditDepartmentDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DepartmentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Department/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Department/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class FinanceReportDataImportService {
  /**
   *
   */
  static import(options: IRequestOptions = {}): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FinanceReportDataImport/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static downloadTemplate(
    params: {
      /**  */
      target?: ImportTarget;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/FinanceReportDataImport/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { target: params['target'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class HostSettingsService {
  /**
   *
   */
  static getAllSettings(options: IRequestOptions = {}): Promise<HostSettingsEditDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/HostSettings/GetAllSettings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateAllSettings(
    params: {
      /** requestBody */
      body?: HostSettingsEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/HostSettings/UpdateAllSettings';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class IncomeRecordService {
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeRecordCreateOrEditDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeRecord/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: IncomeRecordResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeRecord/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeRecord/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      sorting?: string;
      /**  */
      amount?: number;
      /** 请求的门店 */
      orgId?: number;
      /** 备注 */
      remark?: string;
      /** 收入的款项类别id */
      categoryId?: number;
      /**  */
      incomeDateStart?: string;
      /**  */
      incomeDateEnd?: string;
      /**  */
      amountStart?: number;
      /**  */
      amountEnd?: number;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeRecord/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Sorting: params['sorting'],
        Amount: params['amount'],
        OrgId: params['orgId'],
        Remark: params['remark'],
        CategoryId: params['categoryId'],
        IncomeDateStart: params['incomeDateStart'],
        IncomeDateEnd: params['incomeDateEnd'],
        AmountStart: params['amountStart'],
        AmountEnd: params['amountEnd'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: IncomeRecordCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeRecord/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: IncomeRecordCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeRecord/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeRecord/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class IncomeRecordDataImportService {
  /**
   *
   */
  static import(options: IRequestOptions = {}): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeRecordDataImport/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static downloadTemplate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeRecordDataImport/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class IncomeStatisticsService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeStatisticsDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeStatistics/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      year?: number;
      /**  */
      month?: number;
      /** 销售额 */
      saleAmountStart?: number;
      /**  */
      saleAmountEnd?: number;
      /** 实际销售额 */
      actualSaleAmountStart?: number;
      /** 实际销售额 */
      actualSaleAmountEnd?: number;
      /**  */
      remark?: string;
      /**  */
      organizationUnitId?: number;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeStatisticsDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeStatistics/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        Month: params['month'],
        SaleAmountStart: params['saleAmountStart'],
        SaleAmountEnd: params['saleAmountEnd'],
        ActualSaleAmountStart: params['actualSaleAmountStart'],
        ActualSaleAmountEnd: params['actualSaleAmountEnd'],
        Remark: params['remark'],
        OrganizationUnitId: params['organizationUnitId'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeStatisticsCreateOrEditDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeStatistics/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: IncomeStatisticsCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeStatisticsDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeStatistics/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: IncomeStatisticsCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeStatisticsDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeStatistics/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeStatistics/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class IncomeSupplementService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: IncomeSupplementCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeSupplementDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeSupplement/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: IncomeSupplementCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeSupplementDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeSupplement/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: IncomeSupplementPagedResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeSupplement/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static import(options: IRequestOptions = {}): Promise<ImportResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeSupplement/Import';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载导入模板
   */
  static downloadTemplate(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeSupplement/DownloadTemplate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeSupplementDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeSupplement/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      category?: IncomeSupplementCategory;
      /**  */
      year?: number;
      /**  */
      month?: number;
      /**  */
      displayName?: string;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<IncomeSupplementDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeSupplement/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Category: params['category'],
        Year: params['year'],
        Month: params['month'],
        DisplayName: params['displayName'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/IncomeSupplement/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class InvitationRecordService {
  /**
   * 创建邀请，此时只是发起邀请
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrUpdateInvitationRecordDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InvitationRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InvitationRecord/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 接受邀请，当受邀请人完成了分享时设置分享状态为接受
   */
  static appect(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InvitationRecordDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InvitationRecord/Appect';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取我的邀请历史
   */
  static getAll(
    params: {
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<InvitationRecordDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/InvitationRecord/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class LogTestService {
  /**
   *
   */
  static write(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/LogTest/Write';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class NotificationService {
  /**
   *
   */
  static getUserNotifications(
    params: {
      /**  */
      state?: UserNotificationState;
      /**  */
      startDate?: string;
      /**  */
      endDate?: string;
      /**  */
      maxResultCount?: number;
      /**  */
      skipCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetNotificationsOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Notification/GetUserNotifications';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        State: params['state'],
        StartDate: params['startDate'],
        EndDate: params['endDate'],
        MaxResultCount: params['maxResultCount'],
        SkipCount: params['skipCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static setToRead(
    params: {
      /** requestBody */
      body?: GuidEntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Notification/SetToRead';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class OrganizationUnitService {
  /**
   *
   */
  static getOrganizationUnit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetOrganizationUnit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据当前的用户会话，获取其机构下的所有门店
   */
  static getStoresBySession(options: IRequestOptions = {}): Promise<OrganizationUnitDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetStoresBySession';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据当前用户会话，获取其所有子机构及后代机构
   */
  static getOrganizationUnitsOfDescendantBySession(
    params: {
      /**  */
      withMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetOrganizationUnitsOfDescendantBySession';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { withMe: params['withMe'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取指定机构的所有后代机构
   */
  static getOrganizationUnitsOfDescendant(
    params: {
      /** 指定的机构ID。如果参数为空，则是所有机构 */
      orgId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetOrganizationUnitsOfDescendant';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { orgId: params['orgId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrganizationUnitInputGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCurrent(options: IRequestOptions = {}): Promise<OrganizationUnitDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetCurrent';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 修改门店所属的片区
   */
  static changeStoreToNewPartialArea(
    params: {
      /** requestBody */
      body?: ChangeStoreToNewPartialAreaInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/ChangeStoreToNewPartialArea';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 变更片区所属的大区
   */
  static changePartialAreaToNewArea(
    params: {
      /** requestBody */
      body?: ChangePartialAreaToNewBigAreaInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/ChangePartialAreaToNewArea';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取当前登陆用户的管理的机构
   */
  static getOrganizationUnits(
    params: {
      /**  */
      status?: OrganizationStatus;
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetOrganizationUnits';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Status: params['status'],
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取机构用户
   */
  static getOrganizationUnitUsers(
    params: {
      /**  */
      id?: number;
      /**  */
      sorting?: string;
      /**  */
      maxResultCount?: number;
      /**  */
      skipCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitUserListDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetOrganizationUnitUsers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Id: params['id'],
        Sorting: params['sorting'],
        MaxResultCount: params['maxResultCount'],
        SkipCount: params['skipCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 创建新机构
   */
  static createOrganizationUnit(
    params: {
      /** requestBody */
      body?: CreateOrganizationUnitInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/CreateOrganizationUnit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新机构信息
   */
  static updateOrganizationUnit(
    params: {
      /** requestBody */
      body?: UpdateOrganizationUnitInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/UpdateOrganizationUnit';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 移动机构到另一个结点
   */
  static moveOrganizationUnit(
    params: {
      /** requestBody */
      body?: MoveOrganizationUnitInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationUnitDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/MoveOrganizationUnit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 删除机构
   */
  static deleteOrganizationUnit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/DeleteOrganizationUnit';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static removeUsersFromOrganizationUnit(
    params: {
      /** requestBody */
      body?: UsersToOrganizationUnitInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/RemoveUsersFromOrganizationUnit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 从机构中移除用户
   */
  static removeUserFromOrganizationUnit(
    params: {
      /**  */
      userId?: number;
      /**  */
      organizationUnitId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { UserId: params['userId'], OrganizationUnitId: params['organizationUnitId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 机构中添加用户
   */
  static addUsersToOrganizationUnit(
    params: {
      /** requestBody */
      body?: UsersToOrganizationUnitInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新所有机构的OU
   */
  static updateAllOu(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/UpdateAllOU';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 搜索机构用户
   */
  static findUsers(
    params: {
      /** requestBody */
      body?: FindOrganizationUnitUsersInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NameValueDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/FindUsers';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据当前会话，获取所有的子机构及后代机构
   */
  static getOrganizationUnitsForSelect(options: IRequestOptions = {}): Promise<StringStringKeyValuePair[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetOrganizationUnitsForSelect';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 根据当前会话，所有旗下所有门店
   */
  static getStores(options: IRequestOptions = {}): Promise<Int64StringKeyValuePair[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/GetStores';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新所有机构的code信息
   */
  static updateAllOrganizationUnitCodes(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/UpdateAllOrganizationUnitCodes';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static active(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/Active';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static unActive(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/UnActive';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static diffCardOpen(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/DiffCardOpen';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static diffCardClose(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrganizationUnit/DiffCardClose';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class OrgCommentService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: OrgCommentCreateInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrgCommentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrgComment/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 设置置顶显示
   */
  static setAsTop(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrgComment/SetAsTop';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取消置顶显示
   */
  static cancelTop(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrgComment/CancelTop';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 显示该评价
   */
  static showComment(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrgComment/ShowComment';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 隐藏该评价
   */
  static hideComment(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrgComment/HideComment';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 评价的内容 */
      content?: string;
      /** 商户的ID */
      organizationUnitId?: number;
      /**  */
      isShow?: boolean;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrgCommentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrgComment/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Content: params['content'],
        OrganizationUnitId: params['organizationUnitId'],
        IsShow: params['isShow'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrgCommentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrgComment/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: OrgCommentUpdateInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrgCommentDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrgComment/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/OrgComment/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PayService {
  /**
   *
   */
  static merchantNotify(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Pay/MerchantNotify';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static notify(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Pay/Notify';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PaymentCategoryService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      sorting?: string;
      /**  */
      categoryName?: string;
      /**  */
      scope?: PaymentCategoryScope;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PaymentCategoryDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PaymentCategory/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Sorting: params['sorting'],
        CategoryName: params['categoryName'],
        Scope: params['scope'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PaymentCategory/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: PaymentCategoryCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PaymentCategoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PaymentCategory/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: PaymentCategoryCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PaymentCategoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PaymentCategory/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PaymentCategoryCreateOrEditDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PaymentCategory/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCategoryList(options: IRequestOptions = {}): Promise<PaymentCategoryDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PaymentCategory/GetCategoryList';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PaymentCategoryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PaymentCategory/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PayOrderService {
  /**
   * 更新支付的用户信息
   */
  static updatePayUsers(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayOrder/UpdatePayUsers';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: PayOrderResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayOrder/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取得所有支付信息
   */
  static getAll(
    params: {
      /**  */
      billNo?: string;
      /**  */
      isSuccessPay?: boolean;
      /** Format yyyy-MM */
      yearMonth?: string;
      /**  */
      type?: PayOrderType;
      /**  */
      creatorUserId?: number;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayOrderDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayOrder/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BillNo: params['billNo'],
        IsSuccessPay: params['isSuccessPay'],
        YearMonth: params['yearMonth'],
        Type: params['type'],
        CreatorUserId: params['creatorUserId'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PayrollAssignService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollAssignDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollAssign/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      year?: number;
      /**  */
      month?: number;
      /** 姓名 */
      name?: string;
      /** 备注 */
      remark?: string;
      /**  */
      organizationUnitId?: number;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollAssignDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollAssign/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        Month: params['month'],
        Name: params['name'],
        Remark: params['remark'],
        OrganizationUnitId: params['organizationUnitId'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollAssignDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollAssign/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: PayrollAssignCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollAssignDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollAssign/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: PayrollAssignCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollAssignDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollAssign/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollAssign/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PayrollOfPartnerService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollOfPartnerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfPartner/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      year?: number;
      /**  */
      month?: number;
      /**  */
      name?: string;
      /**  */
      organizationUnitId?: number;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollOfPartnerDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfPartner/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        Month: params['month'],
        Name: params['name'],
        OrganizationUnitId: params['organizationUnitId'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollOfPartnerDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfPartner/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: PayrollOfPartnerCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollOfPartnerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfPartner/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: PayrollOfPartnerCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollOfPartnerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfPartner/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfPartner/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PayrollOfSelfService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      year?: number;
      /**  */
      month?: number;
      /**  */
      name?: string;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollOfSelfDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfSelf/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        Month: params['month'],
        Name: params['name'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollOfSelfDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfSelf/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollOfSelfDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfSelf/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: PayrollOfSelfCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollOfSelfDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfSelf/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: PayrollOfSelfCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollOfSelfDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfSelf/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollOfSelf/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PayrollRequisitionService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      sorting?: string;
      /**  */
      amount?: number;
      /**  */
      amountStart?: number;
      /**  */
      amountEnd?: number;
      /**  */
      categoryId?: number;
      /**  */
      creationTimeStart?: string;
      /**  */
      creationTimeEnd?: string;
      /** 需要审批的状态 */
      audit?: number;
      /** 现在审批的状态 */
      auditStatus?: number;
      /**  */
      organizationUnitId?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollRequisitionDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Sorting: params['sorting'],
        Amount: params['amount'],
        AmountStart: params['amountStart'],
        AmountEnd: params['amountEnd'],
        CategoryId: params['categoryId'],
        CreationTimeStart: params['creationTimeStart'],
        CreationTimeEnd: params['creationTimeEnd'],
        Audit: params['audit'],
        AuditStatus: params['auditStatus'],
        OrganizationUnitId: params['organizationUnitId'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 请款单导出
   */
  static export(
    params: {
      /** requestBody */
      body?: PayrollRequisitionResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createFilterForAuditLog(options: IRequestOptions = {}): Promise<PayrollRequisitionAuditLogItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/CreateFilterForAuditLog';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollRequisitionCreateOrEditDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: PayrollRequisitionCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollRequisitionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 待审核的项目如果审核中编辑了,审核状态将清0
   */
  static update(
    params: {
      /** requestBody */
      body?: PayrollRequisitionCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollRequisitionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static startAudit(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/StartAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取得当前登录用户能审核的所有机构的项目
   */
  static getMyAll(
    params: {
      /**  */
      sorting?: string;
      /**  */
      amount?: number;
      /**  */
      amountStart?: number;
      /**  */
      amountEnd?: number;
      /**  */
      categoryId?: number;
      /**  */
      creationTimeStart?: string;
      /**  */
      creationTimeEnd?: string;
      /** 需要审批的状态 */
      audit?: number;
      /** 现在审批的状态 */
      auditStatus?: number;
      /**  */
      organizationUnitId?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollRequisitionDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Sorting: params['sorting'],
        Amount: params['amount'],
        AmountStart: params['amountStart'],
        AmountEnd: params['amountEnd'],
        CategoryId: params['categoryId'],
        CreationTimeStart: params['creationTimeStart'],
        CreationTimeEnd: params['creationTimeEnd'],
        Audit: params['audit'],
        AuditStatus: params['auditStatus'],
        OrganizationUnitId: params['organizationUnitId'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAuditLogs(
    params: {
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollRequisitionDtoAuditUserLogDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/GetMyAuditLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { SkipCount: params['skipCount'], MaxResultCount: params['maxResultCount'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PayrollRequisitionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PayrollRequisition/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PermissionDefinitionService {
  /**
   *
   */
  static getAllPermissionNames(options: IRequestOptions = {}): Promise<StringStringKeyValuePair[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/GetAllPermissionNames';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: PermissionDefinitionCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDefinitionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: PermissionDefinitionCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDefinitionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDefinitionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PermissionDefinitionDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PermissionDefinition/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class PersonalCenterService {
  /**
   * 获取用户活动互动信息(包含点赞、分享、收藏)
   */
  static getPersonalActivityEventAll(
    params: {
      /**  */
      userId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ActivityEventDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PersonalCenter/GetPersonalActivityEventAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { UserId: params['userId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取我收藏的活动
   */
  static getMyFavoriteOfActivityAll(
    params: {
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MyFavoriteOfActivityDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PersonalCenter/GetMyFavoriteOfActivityAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { SkipCount: params['skipCount'], MaxResultCount: params['maxResultCount'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取我收藏的文章
   */
  static getMyFavoriteOfCmsContentAll(
    params: {
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MyFavoriteOfCmsContentDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PersonalCenter/GetMyFavoriteOfCmsContentAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { SkipCount: params['skipCount'], MaxResultCount: params['maxResultCount'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getPersonalCenter(
    params: {
      /**  */
      userId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PersonalCentersDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PersonalCenter/GetPersonalCenter';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { UserId: params['userId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取我现在拥有的积分数额
   */
  static getMyPointAmount(options: IRequestOptions = {}): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PersonalCenter/GetMyPointAmount';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * GetAllCardWithCoupon(获取所有我的会员卡和卡券)
   */
  static getAllCardWithCoupon(options: IRequestOptions = {}): Promise<CardWithCouponDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PersonalCenter/GetAllCardWithCoupon';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取个人中心的统计信息
   */
  static getMyStatistics(options: IRequestOptions = {}): Promise<MyStatisticsDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/PersonalCenter/GetMyStatistics';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ProfitReportService {
  /**
   * 片区利润表
   */
  static getProfitOfPartialArea(
    params: {
      /**  */
      year: number;
      /**  */
      organizationUnitId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProfitReportStandardDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProfitReport/GetProfitOfPartialArea';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Year: params['year'], OrganizationUnitId: params['organizationUnitId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 大区利润表
   */
  static getProfitOfBigArea(
    params: {
      /**  */
      year: number;
      /**  */
      organizationUnitId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProfitReportStandardDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProfitReport/GetProfitOfBigArea';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Year: params['year'], OrganizationUnitId: params['organizationUnitId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 总部利润表
   */
  static getProfitOfHeadquarters(
    params: {
      /**  */
      year?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProfitReportStandardDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProfitReport/GetProfitOfHeadquarters';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取门店利润表
   */
  static getProfitOfStore(
    params: {
      /**  */
      year: number;
      /**  */
      organizationUnitId: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProfitReportStandardDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProfitReport/GetProfitOfStore';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Year: params['year'], OrganizationUnitId: params['organizationUnitId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 重新运行报表计算
   */
  static rerunReportCalc(
    params: {
      /** requestBody */
      body?: RerunReportCalcInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProfitReport/RerunReportCalc';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取当前机构下的所有门店的年度销售报表
   */
  static getStoreYearlySaleReport(
    params: {
      /**  */
      year?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StoreYearlySaleReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProfitReport/GetStoreYearlySaleReport';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取门店的会员卡年度销售报表
   */
  static getStoreYearlyCardSaleReport(
    params: {
      /** 年份 */
      year?: number;
      /** 基础卡Id（可选） */
      baseCardId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StoreYearlyCardSaleReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProfitReport/GetStoreYearlyCardSaleReport';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { year: params['year'], baseCardId: params['baseCardId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 手动触发更新门店会员卡年度销售报表
   */
  static updateStoreYearlyCardSaleReport(
    params: {
      /** 年份 */
      year?: number;
      /** 月份（可选） */
      month?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProfitReport/UpdateStoreYearlyCardSaleReport';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { year: params['year'], month: params['month'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ProjectService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditProjectDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 项目名称 */
      projectName?: string;
      /** 负责人姓名 */
      headmanName?: string;
      /** 是否已审核通过 */
      isAudited?: boolean;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectName: params['projectName'],
        HeadmanName: params['headmanName'],
        IsAudited: params['isAudited'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createFilterForAuditLog(options: IRequestOptions = {}): Promise<ProjectAuditLogItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/CreateFilterForAuditLog';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditProjectDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 待审核的项目如果审核中编辑了,审核状态将清0
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditProjectDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static startAudit(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/StartAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取得当前登录用户能审核的所有机构的项目
   */
  static getMyAll(
    params: {
      /** 项目名称 */
      projectName?: string;
      /** 负责人姓名 */
      headmanName?: string;
      /** 是否已审核通过 */
      isAudited?: boolean;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectName: params['projectName'],
        HeadmanName: params['headmanName'],
        IsAudited: params['isAudited'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAuditLogs(
    params: {
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectDtoAuditUserLogDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/GetMyAuditLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { SkipCount: params['skipCount'], MaxResultCount: params['maxResultCount'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Project/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ProjectLedgerService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      projectTitle?: string;
      /**  */
      projectId?: number;
      /**  */
      occurrenceDate?: string;
      /**  */
      occurrenceDateStart?: string;
      /**  */
      occurrenceDateEnd?: string;
      /**  */
      amountStart?: number;
      /**  */
      amountEnd?: number;
      /**  */
      categoryId?: number;
      /** 项目预算编号 */
      projectBudgetNo?: string;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectLedgerDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectLedger/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectTitle: params['projectTitle'],
        ProjectId: params['projectId'],
        OccurrenceDate: params['occurrenceDate'],
        OccurrenceDateStart: params['occurrenceDateStart'],
        OccurrenceDateEnd: params['occurrenceDateEnd'],
        AmountStart: params['amountStart'],
        AmountEnd: params['amountEnd'],
        CategoryId: params['categoryId'],
        ProjectBudgetNo: params['projectBudgetNo'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectLedgerCreateOrUpdateDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectLedger/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: ProjectLedgerPagedResultDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectLedger/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectLedgerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectLedger/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ProjectLedgerCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectLedgerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectLedger/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ProjectLedgerCreateOrUpdateDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectLedgerDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectLedger/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectLedger/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ProjectPaymentsAndReceiptsService {
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectPaymentsAndReceiptsesDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectPaymentsAndReceipts/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 项目名称 */
      projectName?: string;
      /** 款项类别 */
      category?: ProjectPaymentCategory;
      /** 款项的周期类型 */
      paymentCycleType?: ProjectPaymentCycleType;
      /** 所属项目 */
      projectId?: number;
      /** 收款/拨款 金额 */
      amount?: number;
      /**  */
      onlyMe?: boolean;
      /**  */
      organizationUnitId?: number;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectPaymentsAndReceiptsesDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectPaymentsAndReceipts/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        ProjectName: params['projectName'],
        Category: params['category'],
        PaymentCycleType: params['paymentCycleType'],
        ProjectId: params['projectId'],
        Amount: params['amount'],
        OnlyMe: params['onlyMe'],
        OrganizationUnitId: params['organizationUnitId'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ProjectPaymentsAndReceiptsesCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectPaymentsAndReceiptsesDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectPaymentsAndReceipts/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ProjectPaymentsAndReceiptsesCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectPaymentsAndReceiptsesDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectPaymentsAndReceipts/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectPaymentsAndReceipts/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProjectPaymentsAndReceiptsesCreateOrEditDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectPaymentsAndReceipts/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: ProjectPaymentsAndReceiptsesResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/ProjectPaymentsAndReceipts/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ProtocolService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ProtocolCreateUpdateInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProtocolDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Protocol/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProtocolDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Protocol/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ProtocolCreateUpdateInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProtocolDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Protocol/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      serialNumber?: string;
      /**  */
      displayName?: string;
      /** 签订日期 */
      signingDate?: string;
      /**  */
      signingDateStart?: string;
      /**  */
      signingDateEnd?: string;
      /** 合作周期（单位：年） */
      cooperationPeriod?: number;
      /** 协议类型 */
      type?: ProtocolType;
      /** 备注 */
      remark?: string;
      /**  */
      organizationUnitId?: string;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProtocolDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Protocol/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        SerialNumber: params['serialNumber'],
        DisplayName: params['displayName'],
        SigningDate: params['signingDate'],
        SigningDateStart: params['signingDateStart'],
        SigningDateEnd: params['signingDateEnd'],
        CooperationPeriod: params['cooperationPeriod'],
        Type: params['type'],
        Remark: params['remark'],
        OrganizationUnitId: params['organizationUnitId'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProtocolDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Protocol/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Protocol/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class QuestionService {
  /**
   * 获取当前开放使用中的问卷
   */
  static getOpenQuestion(options: IRequestOptions = {}): Promise<QuestionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Question/GetOpenQuestion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取用户未参与调查的问卷ID。如果用户参与过问卷调查则返回空，否则返回要参与的问卷ID
   */
  static getUnParticipateQuestion(options: IRequestOptions = {}): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Question/GetUnParticipateQuestion';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditQuestionDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Question/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      title?: string;
      /**  */
      status?: AuditFLowStatus;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Question/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Title: params['title'],
        Status: params['status'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取调查结果的统计情况
   */
  static getStatisticsResult(
    params: {
      /**  */
      questionId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionStatisticsDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Question/GetStatisticsResult';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { questionId: params['questionId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Question/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditQuestionDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Question/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditQuestionDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Question/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Question/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class QuestionTopicService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      questionId?: number;
      /**  */
      title?: string;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionTopicDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionTopic/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        QuestionId: params['questionId'],
        Title: params['title'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditQuestionTopicDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionTopic/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionTopicDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionTopic/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditQuestionTopicDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionTopicDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionTopic/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditQuestionTopicDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionTopicDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionTopic/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionTopic/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class QuestionUserRelyService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditQuestionUserReplyDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionUserReplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionUserRely/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 判断用户是否已参与问卷的调查
   */
  static hasBeenInvolvedIn(
    params: {
      /** 问卷ID */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionUserRely/HasBeenInvolvedIn';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionUserReplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionUserRely/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionUserReplyDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionUserRely/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditQuestionUserReplyDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<QuestionUserReplyDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionUserRely/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/QuestionUserRely/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class RefundLogService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      sorting?: string;
      /** 订单号 */
      billNo?: string;
      /** 退款金额（元） */
      price?: number;
      /** 审核状态 */
      auditStatus?: number;
      /** 退款状态 */
      isSuccess?: boolean;
      /**  */
      creationTime?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RefundLogDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Sorting: params['sorting'],
        BillNo: params['billNo'],
        Price: params['price'],
        AuditStatus: params['auditStatus'],
        IsSuccess: params['isSuccess'],
        CreationTime: params['creationTime'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: RefundLogResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRefundDetail(
    params: {
      /**  */
      billNo?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RefundDetailDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/GetRefundDetail';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { billNo: params['billNo'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createFilterForAuditLog(options: IRequestOptions = {}): Promise<RefundLogAuditLogItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/CreateFilterForAuditLog';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: RefundLogDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RefundLogDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 待审核的项目如果审核中编辑了,审核状态将清0
   */
  static update(
    params: {
      /** requestBody */
      body?: RefundLogDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RefundLogDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static startAudit(
    params: {
      /** requestBody */
      body?: Int64EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/StartAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取得当前登录用户能审核的所有机构的项目
   */
  static getMyAll(
    params: {
      /**  */
      sorting?: string;
      /** 订单号 */
      billNo?: string;
      /** 退款金额（元） */
      price?: number;
      /** 审核状态 */
      auditStatus?: number;
      /** 退款状态 */
      isSuccess?: boolean;
      /**  */
      creationTime?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RefundLogDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Sorting: params['sorting'],
        BillNo: params['billNo'],
        Price: params['price'],
        AuditStatus: params['auditStatus'],
        IsSuccess: params['isSuccess'],
        CreationTime: params['creationTime'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAuditLogs(
    params: {
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RefundLogDtoAuditUserLogDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/GetMyAuditLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { SkipCount: params['skipCount'], MaxResultCount: params['maxResultCount'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RefundLogDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/RefundLog/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ReimbursementService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: ReimbursementCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReimbursementDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: ReimbursementCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReimbursementDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: ReimbursementResultRequestDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReimbursementCreateOrEditDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createFilterForAuditLog(options: IRequestOptions = {}): Promise<ReimbursementAuditLogItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/CreateFilterForAuditLog';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 填写凭证号
   */
  static fillVoucherNumber(
    params: {
      /** requestBody */
      body?: FillVoucherNumberInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/FillVoucherNumber';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static exportById(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/ExportById';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static startAudit(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/StartAudit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static audit(
    params: {
      /** requestBody */
      body?: AuditUserLog;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/Audit';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取得当前登录用户能审核的所有机构的项目
   */
  static getMyAll(
    params: {
      /** 报销的申请人 */
      applicant?: string;
      /** 搜索金额 */
      amount?: number;
      /** 最小金额 */
      amountStart?: number;
      /** 最大金额 */
      amountEnd?: number;
      /**  */
      categoryId?: number;
      /** 开始时间 */
      requestDateStart?: string;
      /** 结束时间 */
      requestDateEnd?: string;
      /**  */
      organizationUnitId?: string;
      /**  */
      projectId?: number;
      /** 需要审批的状态 */
      audit?: number;
      /** 现在审批的状态 */
      auditStatus?: number;
      /** 凭证号 */
      voucherNumber?: string;
      /** 项目预算编号 */
      projectBudgetNo?: string;
      /**  */
      ticketCount?: number;
      /** 报销的类型.接受的值:project,org */
      type?: string;
      /**  */
      auditFilterType?: AuditFilterType;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReimbursementDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/GetMyAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Applicant: params['applicant'],
        Amount: params['amount'],
        AmountStart: params['amountStart'],
        AmountEnd: params['amountEnd'],
        CategoryId: params['categoryId'],
        RequestDateStart: params['requestDateStart'],
        RequestDateEnd: params['requestDateEnd'],
        OrganizationUnitId: params['organizationUnitId'],
        ProjectId: params['projectId'],
        Audit: params['audit'],
        AuditStatus: params['auditStatus'],
        VoucherNumber: params['voucherNumber'],
        ProjectBudgetNo: params['projectBudgetNo'],
        TicketCount: params['ticketCount'],
        Type: params['type'],
        AuditFilterType: params['auditFilterType'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMyAuditLogs(
    params: {
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReimbursementDtoAuditUserLogDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/GetMyAuditLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { SkipCount: params['skipCount'], MaxResultCount: params['maxResultCount'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuditUserLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReimbursementDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /** 报销的申请人 */
      applicant?: string;
      /** 搜索金额 */
      amount?: number;
      /** 最小金额 */
      amountStart?: number;
      /** 最大金额 */
      amountEnd?: number;
      /**  */
      categoryId?: number;
      /** 开始时间 */
      requestDateStart?: string;
      /** 结束时间 */
      requestDateEnd?: string;
      /**  */
      organizationUnitId?: string;
      /**  */
      projectId?: number;
      /** 需要审批的状态 */
      audit?: number;
      /** 现在审批的状态 */
      auditStatus?: number;
      /** 凭证号 */
      voucherNumber?: string;
      /** 项目预算编号 */
      projectBudgetNo?: string;
      /**  */
      ticketCount?: number;
      /** 报销的类型.接受的值:project,org */
      type?: string;
      /**  */
      auditFilterType?: AuditFilterType;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ReimbursementDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Reimbursement/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Applicant: params['applicant'],
        Amount: params['amount'],
        AmountStart: params['amountStart'],
        AmountEnd: params['amountEnd'],
        CategoryId: params['categoryId'],
        RequestDateStart: params['requestDateStart'],
        RequestDateEnd: params['requestDateEnd'],
        OrganizationUnitId: params['organizationUnitId'],
        ProjectId: params['projectId'],
        Audit: params['audit'],
        AuditStatus: params['auditStatus'],
        VoucherNumber: params['voucherNumber'],
        ProjectBudgetNo: params['projectBudgetNo'],
        TicketCount: params['ticketCount'],
        Type: params['type'],
        AuditFilterType: params['auditFilterType'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ReportService {
  /**
   * 获取每月续费会员数
   */
  static getRenewVipCountByMonth(
    params: {
      /** 门店ID */
      storeId: number;
      /**  */
      startYear: number;
      /**  */
      startMonth: number;
      /**  */
      endYear: number;
      /**  */
      endMonth: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountMonthlyReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetRenewVipCountByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StoreId: params['storeId'],
        StartYear: params['startYear'],
        StartMonth: params['startMonth'],
        EndYear: params['endYear'],
        EndMonth: params['endMonth']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取每月新增会员数
   */
  static getNewVipCountByMonth(
    params: {
      /** 门店ID */
      storeId: number;
      /**  */
      startYear: number;
      /**  */
      startMonth: number;
      /**  */
      endYear: number;
      /**  */
      endMonth: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountMonthlyReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetNewVipCountByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StoreId: params['storeId'],
        StartYear: params['startYear'],
        StartMonth: params['startMonth'],
        EndYear: params['endYear'],
        EndMonth: params['endMonth']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 会员数量报表（门店端使用）
   */
  static getMemberDataByMonth(
    params: {
      /** 门店ID */
      storeId: number;
      /**  */
      startYear: number;
      /**  */
      startMonth: number;
      /**  */
      endYear: number;
      /**  */
      endMonth: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountMonthlyReportDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetMemberDataByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StoreId: params['storeId'],
        StartYear: params['startYear'],
        StartMonth: params['startMonth'],
        EndYear: params['endYear'],
        EndMonth: params['endMonth']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * V2.0总付费会员数=会员卡+补差卡（不含体验卡）--备注：目前查询包括新增付费与续费对象done
   */
  static getTotalVipMemberCountByMonth(
    params: {
      /** 门店ID */
      storeId: number;
      /**  */
      startYear: number;
      /**  */
      startMonth: number;
      /**  */
      endYear: number;
      /**  */
      endMonth: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountMonthlyReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetTotalVipMemberCountByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StoreId: params['storeId'],
        StartYear: params['startYear'],
        StartMonth: params['startMonth'],
        EndYear: params['endYear'],
        EndMonth: params['endMonth']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * V2.0体验卡会员数
   */
  static getExperienceMemberCountByMonth(
    params: {
      /** 门店ID */
      storeId: number;
      /**  */
      startYear: number;
      /**  */
      startMonth: number;
      /**  */
      endYear: number;
      /**  */
      endMonth: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountMonthlyReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetExperienceMemberCountByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StoreId: params['storeId'],
        StartYear: params['startYear'],
        StartMonth: params['startMonth'],
        EndYear: params['endYear'],
        EndMonth: params['endMonth']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * V2.0新增付费会员数=第一次购买会员卡或补差卡（不含体验卡）
   */
  static getNewPayVipCountByMonth(
    params: {
      /** 门店ID */
      storeId: number;
      /**  */
      startYear: number;
      /**  */
      startMonth: number;
      /**  */
      endYear: number;
      /**  */
      endMonth: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountMonthlyReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetNewPayVipCountByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StoreId: params['storeId'],
        StartYear: params['startYear'],
        StartMonth: params['startMonth'],
        EndYear: params['endYear'],
        EndMonth: params['endMonth']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * V2.0续费会员数=付费会员数-新增付费会员数
   */
  static getRepayVipCountByMonth(
    params: {
      /** 门店ID */
      storeId: number;
      /**  */
      startYear: number;
      /**  */
      startMonth: number;
      /**  */
      endYear: number;
      /**  */
      endMonth: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountMonthlyReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetRepayVipCountByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StoreId: params['storeId'],
        StartYear: params['startYear'],
        StartMonth: params['startMonth'],
        EndYear: params['endYear'],
        EndMonth: params['endMonth']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 体验课转化率
   */
  static getVipConversionRate(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetVipConversionRate';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * v2.0获取当年/月新增会员总数（适用于门店、片区、大区、总部）(购买会员卡人数+购买补差卡人数)
   */
  static getNewVipCountOfYearV2(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetNewVipCountOfYearV2';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取指定年/月线上总销售额（适用于门店、片区、大区、总部）(会员卡，补差卡，体验卡,活动收入之和)
   */
  static getVipSaleStatisticsOfYearV2(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetVipSaleStatisticsOfYearV2';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getSaleStatisticsByMonthOfStoreV2(
    params: {
      /** 门店ID */
      storeId: number;
      /**  */
      startYear: number;
      /**  */
      startMonth: number;
      /**  */
      endYear: number;
      /**  */
      endMonth: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MoneyMonthlyReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetSaleStatisticsByMonthOfStoreV2';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StoreId: params['storeId'],
        StartYear: params['startYear'],
        StartMonth: params['startMonth'],
        EndYear: params['endYear'],
        EndMonth: params['endMonth']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取门店的各月销售统计(会员卡销售+活动销售)
   */
  static getSaleStatisticsByMonthOfStore(
    params: {
      /** 门店ID */
      storeId: number;
      /**  */
      startYear: number;
      /**  */
      startMonth: number;
      /**  */
      endYear: number;
      /**  */
      endMonth: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MoneyMonthlyReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetSaleStatisticsByMonthOfStore';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        StoreId: params['storeId'],
        StartYear: params['startYear'],
        StartMonth: params['startMonth'],
        EndYear: params['endYear'],
        EndMonth: params['endMonth']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取当年/月新增会员总数（适用于门店、片区、大区、总部）
   */
  static getNewVipCountOfTimeSpan(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetNewVipCountOfTimeSpan';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取指定年/月线上总销售额（适用于门店、片区、大区、总部）
   */
  static getVipSaleStatisticsOfTimeSpan(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetVipSaleStatisticsOfTimeSpan';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取在营门店数量（适用于片区、大区、总部）
   */
  static getInOperationStoreCount(
    params: {
      /**  */
      orgId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetInOperationStoreCount';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { orgId: params['orgId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取各分店的会员数量(适用于片区、大区、总部）
   */
  static getVipCountByStore(
    params: {
      /**  */
      orgId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Int32OrgReportItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetVipCountByStore';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { orgId: params['orgId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取各门店的线上销售收入总金额(适用于片区、大区、总部）
   */
  static getStoreSaleStatisticsByTimeSpan(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DecimalOrgReportItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetStoreSaleStatisticsByTimeSpan';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取会员数量（适用于门店/片区/大区/总部）
   */
  static getVipCount(
    params: {
      /**  */
      orgId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetVipCount';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { orgId: params['orgId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取各分店在指定年/月的新增会员数
   */
  static getNewVipCountByTimeSpan(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Int32OrgReportItem[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetNewVipCountByTimeSpan';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取指定年/月续费会员总数(适用于门店/片区/大区/总部）
   */
  static getRenewVipCountByTimeSpan(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetRenewVipCountByTimeSpan';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * 片区/大区/总部-当年2G收入
参数 orgId(可选）year onlyMe:boolean
 */
  static get2GIncomeByYear(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/Get2GIncomeByYear';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * 片区/大区/总部-当年/月2C收入
参数 片区ID（orgId，可选) year(required) month(optional)
 */
  static get2CIncomeByYear(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/Get2CIncomeByYear';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * 片区/大区/总部-当年2B收入
参数 orgId(可选）year onlyMe:boolean
 */
  static get2BIncomeByYear(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/Get2BIncomeByYear';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * 总部-每月各大区2C收入(会员卡+活动销售)
参数 year
 */
  static getArea2CIncomeByMonth(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AreaOrgReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetArea2CIncomeByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * 总部-每月各大区2G收入
参数 year
 */
  static getArea2GIncomeByMonth(
    params: {
      /**  */
      year: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AreaOrgReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetArea2GIncomeByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * 总部-每月各大区2B收入
参数 year
 */
  static getArea2BIncomeByMonth(
    params: {
      /**  */
      year: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AreaOrgReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetArea2BIncomeByMonth';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * 年度月销售数据折线图
参数 orgId(optional) year(required)
1.如果OrgId为空，表示所有的门店销售总和
2.如果orgId不为空，且对应的org为门店，则只统计该门店的
3.如果orgId不为空，且对应的为片区或大区的话，就统计该机构及其后代中，所有门店的数据
 */
  static getAnnualMonthlySalesData(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<MoneyMonthlyReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetAnnualMonthlySalesData';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { OrgId: params['orgId'], Year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取会员总数
   */
  static getMemberTotalNumber(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetMemberTotalNumber';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取年度会员总数
   */
  static getYearMemberTotalNumber(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetYearMemberTotalNumber';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取年度分账收入
   */
  static getYearIncomeAmount(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetYearIncomeAmount';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取年度退款总额
   */
  static getYearRefundTotalPrice(
    params: {
      /**  */
      orgId?: number;
      /**  */
      year: number;
      /**  */
      month?: number;
      /**  */
      onlyMe?: boolean;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Report/GetYearRefundTotalPrice';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrgId: params['orgId'],
        Year: params['year'],
        Month: params['month'],
        OnlyMe: params['onlyMe']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class RoleService {
  /**
   * 创建Role
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateRoleDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取得所有权限
   */
  static getRoles(
    params: {
      /**  */
      permission?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleListDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/GetRoles';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Permission: params['permission'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取得所有权限
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateRoleDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAllPermissions(options: IRequestOptions = {}): Promise<PermissionDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/GetAllPermissions';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoleForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetRoleForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/GetRoleForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RoleDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Role/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SalaryService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      name?: string;
      /**  */
      job?: string;
      /**  */
      year?: number;
      /**  */
      month?: number;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SalaryDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Salary/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Name: params['name'],
        Job: params['job'],
        Year: params['year'],
        Month: params['month'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Salary/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SalaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Salary/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static export(
    params: {
      /** requestBody */
      body?: SalaryPagedResultDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Salary/Export';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: SalaryCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SalaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Salary/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: SalaryCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SalaryDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Salary/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SessionService {
  /**
   *
   */
  static getCurrentLoginInformations(options: IRequestOptions = {}): Promise<GetCurrentLoginInformationsOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Session/GetCurrentLoginInformations';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SocialSecurityAssignService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      year?: number;
      /**  */
      month?: number;
      /**  */
      name?: string;
      /**  */
      remark?: string;
      /**  */
      organizationUnitId?: number;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SocialSecurityAssignDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SocialSecurityAssign/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Year: params['year'],
        Month: params['month'],
        Name: params['name'],
        Remark: params['remark'],
        OrganizationUnitId: params['organizationUnitId'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SocialSecurityAssignDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SocialSecurityAssign/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SocialSecurityAssignDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SocialSecurityAssign/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: SocialSecurityAssignCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SocialSecurityAssignDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SocialSecurityAssign/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: SocialSecurityAssignCreateOrEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SocialSecurityAssignDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SocialSecurityAssign/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SocialSecurityAssign/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SplitBillService {
  /**
   * 获取分账账单数据
   */
  static getAllBills(
    params: {
      /** 账单日 */
      billDate?: string;
      /** 片区id */
      partialAreaId?: number;
      /** 门店id */
      storeId?: number;
      /** 只看有订单数据的 */
      onlyViewHasPayOrder?: boolean;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SplitBillDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SplitBill/GetAllBills';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BillDate: params['billDate'],
        PartialAreaId: params['partialAreaId'],
        StoreId: params['storeId'],
        OnlyViewHasPayOrder: params['onlyViewHasPayOrder'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取分账账单的统计
   */
  static getBillStatistics(
    params: {
      /**  */
      billId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SplitBillStatisticsDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SplitBill/GetBillStatistics';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { billId: params['billId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 下载账单
   */
  static downloadBill(
    params: {
      /**  */
      billId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SplitBill/DownloadBill';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { billId: params['billId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取账单信息
   */
  static getSplitBill(
    params: {
      /** 账单id */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SplitBillDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SplitBill/GetSplitBill';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取分账账单的明细数据
   */
  static getAllBillDetails(
    params: {
      /**  */
      billDate?: string;
      /** 门店id */
      organizationUnitId?: number;
      /** 分账账单id */
      billId?: number;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SplitBillDetailDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SplitBill/GetAllBillDetails';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        BillDate: params['billDate'],
        OrganizationUnitId: params['organizationUnitId'],
        BillId: params['billId'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取分账回退信息
   */
  static getSplitReturns(
    params: {
      /**  */
      splitBillDetailId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SplitBillReturnDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SplitBill/GetSplitReturns';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { splitBillDetailId: params['splitBillDetailId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SplitReportService {
  /**
   * 根据共建机构（加盟商），获取分给平台的金额
   */
  static getSplitToPlatformOfPartialArea(
    params: {
      /** 片区id */
      organizationUnitId?: number;
      /** 按年份 */
      year?: number;
      /** 按账单日 */
      billDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SplitReport/GetSplitToPlatformOfPartialArea';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrganizationUnitId: params['organizationUnitId'],
        Year: params['year'],
        BillDate: params['billDate']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取分给共建机构（加盟商）的金额
   */
  static getSplitToAllianceBusiness(
    params: {
      /** 片区id */
      organizationUnitId?: number;
      /** 按年份 */
      year?: number;
      /** 按账单日 */
      billDate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SplitReport/GetSplitToAllianceBusiness';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrganizationUnitId: params['organizationUnitId'],
        Year: params['year'],
        BillDate: params['billDate']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取分账给平台的金额
   */
  static getSplitToPlatform(
    params: {
      /** 账单日期 */
      billDate?: string;
      /** 年份 */
      year?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/SplitReport/GetSplitToPlatform';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { BillDate: params['billDate'], Year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class StoreSplitAccountReportService {
  /**
   * 更新固定费用的显示名称
   */
  static updateFeeDisplayNames(
    params: {
      /** requestBody */
      body?: SplitAccountFeeDisplayConfigureDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/StoreSplitAccountReport/UpdateFeeDisplayNames';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取固定费用的显示名称
   */
  static getFeeDisplayNames(options: IRequestOptions = {}): Promise<SplitAccountFeeDisplayConfigureDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/StoreSplitAccountReport/GetFeeDisplayNames';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 修改报表的固定费用参数
   */
  static update(
    params: {
      /** requestBody */
      body?: StoreSplitAccountReportChangeInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StoreSplitAccountReportDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/StoreSplitAccountReport/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取报表数据
   */
  static getReport(
    params: {
      /**  */
      year?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StoreSplitAccountReportDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/StoreSplitAccountReport/GetReport';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Year: params['year'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取报表的费用变更记录
   */
  static getFeeChangeLogs(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<StoreSplitAccountReportFeeChangeHistoryDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/StoreSplitAccountReport/GetFeeChangeLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class SwiperService {
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SwiperDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getByGroupId(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SwiperDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/GetByGroupId';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      copyFromViewType?: CopyFromViewType;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SwiperDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        CopyFromViewType: params['copyFromViewType'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 同步
   */
  static sync(
    params: {
      /** requestBody */
      body?: Int32EntityDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/Sync';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SwiperDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: SwiperDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SwiperDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: SwiperDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SwiperDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Swiper/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class TenantService {
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateTenantDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Tenant/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Tenant/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Tenant/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      isActive?: boolean;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Tenant/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        IsActive: params['isActive'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: TenantDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<TenantDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Tenant/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class TenantSettingsService {
  /**
   *
   */
  static getAllSettings(options: IRequestOptions = {}): Promise<TenantSettingsEditDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantSettings/GetAllSettings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAliyunOssSettings(options: IRequestOptions = {}): Promise<AliyunOssSettingsEditDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantSettings/GetAliyunOssSettings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getMailSettings(options: IRequestOptions = {}): Promise<MailSettingsEditDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantSettings/GetMailSettings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateAllSettings(
    params: {
      /** requestBody */
      body?: TenantSettingsEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantSettings/UpdateAllSettings';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateMailSettings(
    params: {
      /** requestBody */
      body?: MailSettingsEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantSettings/UpdateMailSettings';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static updateAliyunOssSettings(
    params: {
      /** requestBody */
      body?: AliyunOssSettingsEditDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/TenantSettings/UpdateAliyunOssSettings';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class TokenAuthService {
  /**
   *
   */
  static authenticate(
    params: {
      /** requestBody */
      body?: AuthenticateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AuthenticateResultModel> {
    return new Promise((resolve, reject) => {
      let url = '/api/TokenAuth/Authenticate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static refreshToken(options: IRequestOptions = {}): Promise<AuthenticateResultModel> {
    return new Promise((resolve, reject) => {
      let url = '/api/TokenAuth/RefreshToken';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getExternalAuthenticationProviders(options: IRequestOptions = {}): Promise<ExternalLoginProviderInfoModel[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/TokenAuth/GetExternalAuthenticationProviders';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static externalAuthenticate(
    params: {
      /** requestBody */
      body?: ExternalAuthenticateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalAuthenticateResultModel> {
    return new Promise((resolve, reject) => {
      let url = '/api/TokenAuth/ExternalAuthenticate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static weixinMiniAuthenticate(
    params: {
      /** requestBody */
      body?: WeChatMiniProgramAuthenticateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ExternalAuthenticateResultModel> {
    return new Promise((resolve, reject) => {
      let url = '/api/TokenAuth/WeixinMiniAuthenticate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getWeixinMiniPhone(
    params: {
      /** requestBody */
      body?: WeChatMiniProgramAuthenticateModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/TokenAuth/GetWeixinMiniPhone';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UserService {
  /**
   *
   */
  static getAll(
    params: {
      /** UserName , Name ,EmailAddress */
      keyword?: string;
      /** 宝贝姓名 */
      babyName?: string;
      /** 宝贝昵称 */
      babyNickName?: string;
      /** 宝贝联系人姓名 */
      contactName?: string;
      /**  */
      isActive?: boolean;
      /** 是否获取用户的会员卡的余额 */
      isGetUserVipCardBalance?: boolean;
      /** 是否获取用户的补差卡余额 */
      isGetUserDiffCardBalance?: boolean;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        BabyName: params['babyName'],
        BabyNickName: params['babyNickName'],
        ContactName: params['contactName'],
        IsActive: params['isActive'],
        IsGetUserVipCardBalance: params['isGetUserVipCardBalance'],
        IsGetUserDiffCardBalance: params['isGetUserDiffCardBalance'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUserDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取得本组织和上级组织的用户
   */
  static getCurrentOrganizationUsers(options: IRequestOptions = {}): Promise<UserBaseDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetCurrentOrganizationUsers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取机构的所有会员用户
   */
  static getAllOrganizationWechatUser(
    params: {
      /**  */
      organizationUnitId?: number;
      /** UserName , Name ,EmailAddress */
      keyword?: string;
      /** 宝贝姓名 */
      babyName?: string;
      /** 宝贝昵称 */
      babyNickName?: string;
      /** 宝贝联系人姓名 */
      contactName?: string;
      /**  */
      isActive?: boolean;
      /** 是否获取用户的会员卡的余额 */
      isGetUserVipCardBalance?: boolean;
      /** 是否获取用户的补差卡余额 */
      isGetUserDiffCardBalance?: boolean;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<OrganizationWechatUserDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetAllOrganizationWechatUser';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        OrganizationUnitId: params['organizationUnitId'],
        Keyword: params['keyword'],
        BabyName: params['babyName'],
        BabyNickName: params['babyNickName'],
        ContactName: params['contactName'],
        IsActive: params['isActive'],
        IsGetUserVipCardBalance: params['isGetUserVipCardBalance'],
        IsGetUserDiffCardBalance: params['isGetUserDiffCardBalance'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUserForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetUserForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetUserForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static createOrUpdateUser(
    params: {
      /** requestBody */
      body?: CreateOrUpdateUserInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/CreateOrUpdateUser';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: UserDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getRoles(options: IRequestOptions = {}): Promise<RoleDtoListResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetRoles';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static changeLanguage(
    params: {
      /** requestBody */
      body?: ChangeUserLanguageDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/ChangeLanguage';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static changePassword(
    params: {
      /** requestBody */
      body?: ChangePasswordDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/ChangePassword';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static resetPassword(
    params: {
      /** requestBody */
      body?: ResetPasswordDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/ResetPassword';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 导出用户和宝贝的信息
   */
  static exportUserWithBaby(
    params: {
      /** requestBody */
      body?: UserPagedResultDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/ExportUserWithBaby';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取用户信息以编辑(小程序端使用)
   */
  static getMiniUserForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserEditDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetMiniUserForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 小程序端个人资料编辑用户信息
   */
  static updateMiniUser(
    params: {
      /** requestBody */
      body?: MiniUserDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/UpdateMiniUser';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取个人数据统计(小程序端使用)
   */
  static getPersonalCenterStatistics(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetPersonalCenterStatisticsDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/GetPersonalCenterStatistics';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/User/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UserCardService {
  /**
   *
   */
  static getForEdit(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CreateOrEditUserCardDtoGetForEditOutput> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/GetForEdit';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 更新会员卡的截止日期
   */
  static updateEndDate(
    params: {
      /** requestBody */
      body?: UpdateUserCardEndDateInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/UpdateEndDate';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserCardDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 冻结会员卡
   */
  static freeze(
    params: {
      /** 退款原因描述 */
      desc: string;
      /** 会员卡ID */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/Freeze';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { desc: params['desc'], Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 冻结会员卡
   */
  static enable(
    params: {
      /** 退款原因描述 */
      desc: string;
      /** 会员卡ID */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/Enable';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { desc: params['desc'], Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 取得用户的会员卡列表
   */
  static getUserCards(
    params: {
      /**  */
      userId?: number;
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserCardDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/GetUserCards';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { UserId: params['userId'], Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取用户的补差卡的余额
   */
  static getUserDiffCardBalance(
    params: {
      /**  */
      userId?: number;
      /** 门店ID，如果此参数为空，则统计用户在所有门店的补差卡的余额 */
      organizationUnitId?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/GetUserDiffCardBalance';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { UserId: params['userId'], OrganizationUnitId: params['organizationUnitId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 费用扣除
   */
  static deduction(
    params: {
      /** requestBody */
      body?: UserCardDeductionInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/Deduction';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static revoke(
    params: {
      /**  */
      billNo?: string;
      /**  */
      desc?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/Revoke';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { BillNo: params['billNo'], desc: params['desc'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLogs(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserCardLogDto[]> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/GetLogs';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 申请退款
   */
  static refund(
    params: {
      /**  */
      totalPrice?: number;
      /**  */
      desc: string;
      /**  */
      auditFlowId: string;
      /**  */
      id?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/Refund';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        TotalPrice: params['totalPrice'],
        Desc: params['desc'],
        AuditFlowId: params['auditFlowId'],
        Id: params['id']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      userId?: number;
      /**  */
      cardId?: number;
      /**  */
      cardSkuId?: number;
      /** 是否要获取当前可用的会员卡(未过期的，还有余额的) */
      isGetAvailable?: boolean;
      /**  */
      status?: UserCardStatus;
      /**  */
      sorting?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserCardDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        UserId: params['userId'],
        CardId: params['cardId'],
        CardSkuId: params['cardSkuId'],
        IsGetAvailable: params['isGetAvailable'],
        Status: params['status'],
        Sorting: params['sorting'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateOrEditUserCardDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserCardDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: CreateOrEditUserCardDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserCardDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserCard/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UserDiffCardService {
  /**
   * 补差卡支付
   */
  static getPay(
    params: {
      /**  */
      price?: number;
      /**  */
      memo?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WxPayResult> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserDiffCard/GetPay';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { price: params['price'], memo: params['memo'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static refund(
    params: {
      /** requestBody */
      body?: UserDiffCardRefundInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserDiffCard/Refund';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UserPointLogService {
  /**
   * 积分日志查询
   */
  static getAll(
    params: {
      /**  */
      userId?: number;
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserPointLogDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserPointLog/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        UserId: params['userId'],
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * 获取我的积分的记录
   */
  static my(
    params: {
      /**  */
      userId?: number;
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserPointLogDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserPointLog/My';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        UserId: params['userId'],
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateUserPointLogDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<number> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/UserPointLog/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class WechatService {
  /**
   *
   */
  static getAuthorizeUrl(
    params: {
      /**  */
      redirectUri?: string;
      /**  */
      state?: string;
      /**  */
      scope?: AuthorizeScope;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Wechat/GetAuthorizeUrl';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { redirectUri: params['redirectUri'], state: params['state'], scope: params['scope'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUserAccessToken(
    params: {
      /**  */
      code?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAuthorizeAccessTokenResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Wechat/GetUserAccessToken';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { code: params['code'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static receiveMessage(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Wechat/ReceiveMessage';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static receiveMessage1(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Wechat/ReceiveMessage';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTempQrCode(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/Wechat/GetTempQrCode';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class WechatAppService2Service {
  /**
   *
   */
  static getAuthorizeUrl(
    params: {
      /**  */
      redirectUri?: string;
      /**  */
      state?: string;
      /**  */
      scope?: AuthorizeScope;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatAppService2/GetAuthorizeUrl';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { redirectUri: params['redirectUri'], state: params['state'], scope: params['scope'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getUserAccessToken(
    params: {
      /**  */
      code?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UserAuthorizeAccessTokenResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatAppService2/GetUserAccessToken';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { code: params['code'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static receiveMessage(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatAppService2/ReceiveMessage';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static receiveMessage1(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatAppService2/ReceiveMessage';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTempQrCode(options: IRequestOptions = {}): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatAppService2/GetTempQrCode';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class WechatMessageSubscribeService {
  /**
   *
   */
  static cancelSubscribe(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatMessageSubscribe/CancelSubscribe';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static isSubscribed(options: IRequestOptions = {}): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatMessageSubscribe/IsSubscribed';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static subscribe(
    params: {
      /** requestBody */
      body?: SubscribeInput;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatMessageSubscribe/Subscribe';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class WechatUserinfoService {
  /**
   *
   */
  static getAll(
    params: {
      /**  */
      keyword?: string;
      /**  */
      userName?: string;
      /**  */
      isActive?: boolean;
      /**  */
      sorting?: string;
      /**  */
      from?: string;
      /**  */
      to?: string;
      /**  */
      skipCount?: number;
      /**  */
      maxResultCount?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WechatUserinfoDtoPagedResultDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatUserinfo/GetAll';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Keyword: params['keyword'],
        UserName: params['userName'],
        IsActive: params['isActive'],
        Sorting: params['sorting'],
        From: params['from'],
        To: params['to'],
        SkipCount: params['skipCount'],
        MaxResultCount: params['maxResultCount']
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static get(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WechatUserinfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatUserinfo/Get';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: WechatUserinfoDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WechatUserinfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatUserinfo/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /** requestBody */
      body?: WechatUserinfoDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<WechatUserinfoDto> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatUserinfo/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static delete(
    params: {
      /**  */
      id?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '/api/services/app/WechatUserinfo/Delete';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { Id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export interface Activity {
  /**  */
  title?: string;

  /**  */
  suitableDesc?: string;

  /**  */
  titleImagePath?: string;

  /**  */
  activityStartTime?: Date;

  /**  */
  activityEndTime?: Date;

  /**  */
  applyEndTime?: Date;

  /**  */
  isLimitCount?: boolean;

  /**  */
  maxCount?: number;

  /**  */
  minCount?: number;

  /**  */
  applyCount?: number;

  /**  */
  signUpCount?: number;

  /**  */
  viewCount?: number;

  /**  */
  status?: ActivityStatus;

  /**  */
  orginalPrice?: number;

  /**  */
  price?: number;

  /**  */
  placeDetail?: PlaceDetail;

  /**  */
  description?: string;

  /**  */
  applies?: ActivityApply[];

  /**  */
  isNeedAudit?: boolean;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  collentionCount?: number;

  /**  */
  shareCount?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  lastModifierUser?: User;

  /**  */
  tenantId?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  organizationUnitId?: number;

  /**  */
  extensionData?: string;

  /**  */
  organizationUnit?: AgileOrganizationUnit;

  /**  */
  domainEvents?: IEventData[];

  /**  */
  id?: number;
}

export interface ActivityApply {
  /**  */
  isSettled?: boolean;

  /**  */
  settledTime?: Date;

  /**  */
  settledLogId?: number;

  /**  */
  isCheckOut?: boolean;

  /**  */
  checkOutTime?: Date;

  /**  */
  checkOutType?: string;

  /**  */
  status?: ActivityApplyStatus;

  /**  */
  activityId?: number;

  /**  */
  totalPaid?: number;

  /**  */
  totalPrice?: number;

  /**  */
  memo?: string;

  /**  */
  ip?: string;

  /**  */
  headImgUrl?: string;

  /**  */
  babyName?: string;

  /**  */
  realName?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  clientType?: string;

  /**  */
  commentCount?: number;

  /**  */
  approvedTime?: Date;

  /**  */
  approvedUserId?: number;

  /**  */
  approvedRemark?: string;

  /**  */
  rejectTime?: Date;

  /**  */
  rejectRemark?: string;

  /**  */
  cancelTime?: Date;

  /**  */
  cancelRemark?: string;

  /**  */
  activity?: Activity;

  /**  */
  billNo?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  tenantId?: number;

  /**  */
  extensionData?: string;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  lastModifierUser?: User;

  /**  */
  isDeleted?: boolean;

  /**  */
  domainEvents?: IEventData[];

  /**  */
  id?: number;
}

export interface ActivityApplyBaseDto {
  /**  */
  status?: ActivityApplyStatus;

  /**  */
  babyName?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  creationTime?: Date;

  /**  */
  headImgUrl?: string;

  /**  */
  id?: number;
}

export interface ActivityApplyDto {
  /** 已支付金额 */
  totalPaid?: number;

  /** 订单金额 */
  totalPrice?: number;

  /** 订单号 */
  billNo?: string;

  /**  */
  activity?: ActivityDtoBase;

  /**  */
  creatorUser?: UserDtoBase;

  /** 联系人 */
  realName?: string;

  /** 留言数量 */
  commentCount?: number;

  /** 备注 */
  memo?: string;

  /** 是否已核销 */
  isCheckOut?: boolean;

  /** 核销时间 */
  checkOutTime?: Date;

  /**  */
  organizationUnitId?: number;

  /**  */
  status?: ActivityApplyStatus;

  /**  */
  babyName?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  creationTime?: Date;

  /**  */
  headImgUrl?: string;

  /**  */
  id?: number;
}

export interface ActivityApplyDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ActivityApplyDto[];
}

export interface ActivityAuditLogItem {
  /**  */
  log?: AuditUserLog;

  /**  */
  entity?: Activity;
}

export interface ActivityDto {
  /**  */
  title?: string;

  /**  */
  suitableDesc?: string;

  /**  */
  titleImagePath?: string;

  /**  */
  activityStartTime?: Date;

  /**  */
  activityEndTime?: Date;

  /**  */
  applyEndTime?: Date;

  /** 是否限制目标报名人数 */
  isLimitCount?: boolean;

  /** 最大报名人数 */
  maxCount?: number;

  /** 最少报名人数 */
  minCount?: number;

  /** 报名申请人次 */
  applyCount?: number;

  /** 报名成功人次 */
  signUpCount?: number;

  /** 查看次数 */
  viewCount?: number;

  /** 活动状态 AgileBoost.TongMeng.Entities.Enums.ActivityStatusEnum */
  status?: number;

  /**  */
  orginalPrice?: number;

  /**  */
  price?: number;

  /**  */
  placeDetail?: PlaceDetail;

  /**  */
  description?: string;

  /**  */
  applies?: ActivityApplyBaseDto[];

  /**  */
  userApply?: ActivityApplyBaseDto;

  /** 存放用户关注等事件 */
  userEvents?: EventTypeEnum[];

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  auditFlow?: AuditFlowDto;

  /**  */
  currentAuditNodes?: AuditNodeDto[];

  /**  */
  id?: number;
}

export interface ActivityDtoAuditUserLogDto {
  /**  */
  detail?: ActivityDto;

  /**  */
  log?: AuditUserLogDto;
}

export interface ActivityDtoAuditUserLogDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ActivityDtoAuditUserLogDto[];
}

export interface ActivityDtoBase {
  /** 活动名称 */
  title?: string;

  /** 活动图片 */
  titleImagePath?: string;

  /** 活动开始时间 */
  activityStartTime?: Date;

  /** 活动结束时间 */
  activityEndTime?: Date;

  /** 活动价格 */
  price?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  ou?: AgileOrganizationUnitDtoBase;

  /** 活动的开展地址 */
  place?: string;

  /**  */
  id?: number;
}

export interface ActivityDtoListResultDto {
  /**  */
  items?: ActivityDto[];
}

export interface ActivityDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ActivityDto[];
}

export interface ActivityEventDto {
  /**  */
  eventType?: string;

  /**  */
  creationTime?: Date;

  /**  */
  activity?: Activity;

  /**  */
  creatorUser?: User;

  /**  */
  id?: number;
}

export interface AgileOrganizationUnit {
  /**  */
  status?: OrganizationStatus;

  /**  */
  isLeaf?: boolean;

  /**  */
  displayOrder?: number;

  /**  */
  ou?: string;

  /**  */
  level?: OrganizationUnitLevel;

  /**  */
  detail?: OrganizationUnitDetail;

  /**  */
  parent?: AgileOrganizationUnit;

  /**  */
  userOrganizationUnits?: UserOrganizationUnit[];

  /**  */
  extensionData?: string;

  /**  */
  subMchId?: string;

  /**  */
  isActive?: boolean;

  /**  */
  subPayEnable?: boolean;

  /**  */
  diffCardEnable?: boolean;

  /**  */
  isAllianceBusiness?: boolean;

  /**  */
  storeType?: StoreType;

  /**  */
  storeMainType?: StoreMainType;

  /**  */
  principalName?: string;

  /**  */
  splitFeeSetting?: SplitFeeSetting;

  /**  */
  storeSplitSetting?: SplitSetting;

  /**  */
  defaultSplitByJointOperation?: SplitSetting;

  /**  */
  defaultSplitByPartnership?: SplitSetting;

  /**  */
  defaultSplitByAllianceBusinessSelf?: SplitSetting;

  /**  */
  cycleSetting?: string;

  /**  */
  lastBillDate?: string;

  /**  */
  tenantId?: number;

  /**  */
  parentId?: number;

  /**  */
  code?: string;

  /**  */
  displayName?: string;

  /**  */
  children?: OrganizationUnit[];

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface AgileOrganizationUnitDtoBase {
  /**  */
  displayName?: string;

  /**  */
  logoImgUrl?: string;

  /**  */
  desc?: string;

  /**  */
  status?: number;

  /**  */
  type?: number;

  /**  */
  id?: number;
}

export interface AliyunOssSettingsEditDto {
  /**  */
  bucketName?: string;

  /**  */
  endPoint?: string;

  /**  */
  accessId?: string;

  /**  */
  accessKey?: string;

  /**  */
  fileUrl?: string;

  /**  */
  imageUrl?: string;
}

export interface ApplicationInfoDto {
  /**  */
  name?: string;

  /**  */
  version?: string;

  /**  */
  releaseDate?: Date;

  /**  */
  features?: object;
}

export interface ApplyRepayInput {
  /**  */
  clientType?: ClientType;

  /**  */
  id?: number;
}

export interface AreaOrgItem {
  /**  */
  orgId?: number;

  /**  */
  orgName?: string;

  /**  */
  detail?: MoneyMonthlyReportDto;
}

export interface AreaOrgReportDto {
  /**  */
  total?: number;

  /**  */
  items?: AreaOrgItem[];
}

export interface AttachmentDto {
  /**  */
  fileName?: string;

  /** 文件的扩展名 */
  extension?: string;

  /** 是否为临时文件 */
  isTemp?: boolean;

  /**  */
  url?: string;

  /** 附件的宿主ID */
  hostId?: string;

  /**  */
  hostType?: AttachmentHostType;

  /** 文件的长度大小(单位：字节） */
  contentLength?: number;

  /** 文件的大小(自动计算的属性) */
  fileSize?: string;

  /**  */
  id?: number;
}

export interface AuditFlow {
  /**  */
  title?: string;

  /**  */
  desc?: string;

  /**  */
  nodesMaxIndex?: number;

  /**  */
  status?: AuditFLowStatus;

  /**  */
  type?: AuditFlowType;

  /**  */
  auditNodes?: AuditNode[];

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  lastModifierUser?: User;

  /**  */
  isDeleted?: boolean;

  /**  */
  extensionData?: string;

  /**  */
  tenantId?: number;

  /**  */
  id?: string;
}

export interface AuditFlowDto {
  /** 标题 */
  title?: string;

  /** 描述 */
  desc?: string;

  /**  */
  status?: AuditFLowStatus;

  /**  */
  type?: AuditFlowType;

  /**  */
  nodesMaxIndex?: number;

  /** 节点 */
  auditNodes?: AuditNodeDto[];

  /**  */
  id?: string;
}

export interface AuditFlowDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: AuditFlowDto[];
}

export interface AuditLogListDto {
  /**  */
  userId?: number;

  /**  */
  userName?: string;

  /**  */
  impersonatorTenantId?: number;

  /**  */
  impersonatorUserId?: number;

  /**  */
  serviceName?: string;

  /**  */
  methodName?: string;

  /**  */
  parameters?: string;

  /**  */
  executionTime?: Date;

  /**  */
  executionDuration?: number;

  /**  */
  clientIpAddress?: string;

  /**  */
  clientName?: string;

  /**  */
  browserInfo?: string;

  /**  */
  exception?: string;

  /**  */
  customData?: string;

  /**  */
  id?: number;
}

export interface AuditLogListDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: AuditLogListDto[];
}

export interface AuditNode {
  /**  */
  desc?: string;

  /**  */
  roleName?: string;

  /**  */
  roleId?: number;

  /**  */
  userName?: string;

  /**  */
  userId?: number;

  /**  */
  index?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  auditFlow?: AuditFlow;

  /**  */
  tenantId?: number;

  /**  */
  id?: string;
}

export interface AuditNodeDto {
  /**  */
  desc?: string;

  /**  */
  roleName?: string;

  /**  */
  roleId?: number;

  /**  */
  userName?: string;

  /**  */
  userId?: number;

  /**  */
  index?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  tenantId?: number;

  /**  */
  iCanAudit?: boolean;

  /**  */
  id?: string;
}

export interface AuditNodePreDefineDto {
  /**  */
  desc?: string;

  /**  */
  roleName?: string;

  /**  */
  roleId?: number;

  /**  */
  userName?: string;

  /**  */
  userId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  user?: MiniUserDto;

  /**  */
  role?: RoleMiniDto;

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /**  */
  id?: string;
}

export interface AuditNodePreDefineDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: AuditNodePreDefineDto[];
}

export interface AuditUserLog {
  /**  */
  hostId?: string;

  /**  */
  hostType?: AuditUserLogType;

  /**  */
  auditFlowId?: string;

  /**  */
  auditNodeId?: string;

  /**  */
  status?: AuditUserLogStatus;

  /**  */
  desc?: string;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  tenantId?: number;

  /**  */
  auditStatus?: number;

  /**  */
  expired?: boolean;

  /**  */
  id?: number;
}

export interface AuditUserLogDto {
  /**  */
  hostType?: AuditUserLogType;

  /**  */
  status?: AuditUserLogStatus;

  /**  */
  desc?: string;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUser?: UserDtoBase;

  /**  */
  creatorUserId?: number;

  /**  */
  expired?: boolean;

  /**  */
  auditNodeId?: string;

  /**  */
  id?: number;
}

export interface AuthenticateModel {
  /**  */
  userNameOrEmailAddress?: string;

  /**  */
  password?: string;

  /**  */
  rememberClient?: boolean;
}

export interface AuthenticateResultModel {
  /**  */
  accessToken?: string;

  /**  */
  encryptedAccessToken?: string;

  /**  */
  expireInSeconds?: number;

  /**  */
  userId?: number;
}

export interface BabyMiniDto {
  /**  */
  realname?: string;

  /** 宝宝昵称 */
  nickname?: string;

  /**  */
  sex?: SexEnum;

  /** 生日 */
  birthday?: Date;

  /** 宝宝联系人 */
  contactName?: string;

  /** 宝宝 联系人电话 */
  contactPhone?: string;

  /** 联系人与宝宝关系 */
  contactDesc?: string;
}

export interface BoolMessage {
  /**  */
  success?: boolean;

  /**  */
  message?: string;
}

export interface Card {
  /**  */
  title?: string;

  /**  */
  titleImageUrl?: string;

  /**  */
  desc?: string;

  /**  */
  ageDesc?: string;

  /**  */
  startTime?: Date;

  /**  */
  endTime?: Date;

  /**  */
  status?: number;

  /**  */
  isShow?: boolean;

  /**  */
  inventoryNum?: number;

  /**  */
  memberInfo?: string;

  /**  */
  buyInfo?: string;

  /**  */
  cardsTypeInfo?: string;

  /**  */
  baseCardId?: number;

  /**  */
  lastSyncTime?: Date;

  /**  */
  isDeleted?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  lastModifierUser?: User;

  /**  */
  extensionData?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  cardSkus?: CardSku[];

  /**  */
  tenantId?: number;

  /**  */
  id?: number;
}

export interface CardDetailReportInput {
  /**  */
  organizationId?: number;

  /**  */
  year?: number;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface CardDetailReportItemDto {
  /**  */
  userName?: string;

  /**  */
  userId?: number;

  /**  */
  details?: CardDetailReportOfOrgDto[];
}

export interface CardDetailReportItemDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CardDetailReportItemDto[];
}

export interface CardDetailReportOfBuyDto {
  /**  */
  type?: UserBuyCardType;

  /** 购买金额 */
  buy?: number;
}

export interface CardDetailReportOfOrgDto {
  /**  */
  orgName?: string;

  /**  */
  orgId?: number;

  /**  */
  skuList?: CardDetailReportOfSkuDto[];
}

export interface CardDetailReportOfSkuDto {
  /**  */
  cardName?: string;

  /**  */
  cardSkuName?: string;

  /**  */
  cardSkuId?: number;

  /**  */
  cardFullName?: string;

  /**  */
  consumeDetails?: object;

  /**  */
  buyDetails?: object;
}

export interface CardDto {
  /**  */
  title?: string;

  /**  */
  titleImageUrl?: string;

  /**  */
  desc?: string;

  /**  */
  ageDesc?: string;

  /**  */
  startTime?: Date;

  /**  */
  endTime?: Date;

  /**  */
  status?: number;

  /**  */
  inventoryNum?: number;

  /**  */
  memberInfo?: string;

  /**  */
  buyInfo?: string;

  /**  */
  cardsTypeInfo?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  isShow?: boolean;

  /**  */
  baseCardId?: number;

  /** 上次同步时间 */
  lastSyncTime?: Date;

  /**  */
  cardSkus?: CardSkuDto[];

  /**  */
  id?: number;
}

export interface CardDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CardDto[];
}

export interface CardSku {
  /**  */
  title?: string;

  /**  */
  cardId?: number;

  /**  */
  status?: number;

  /**  */
  card?: Card;

  /**  */
  originPrice?: number;

  /**  */
  price?: number;

  /**  */
  desc?: string;

  /**  */
  durationMonth?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  lastModifierUser?: User;

  /**  */
  extensionData?: string;

  /**  */
  tenantId?: number;

  /**  */
  baseCardSkuId?: number;

  /**  */
  lastSyncTime?: Date;

  /**  */
  id?: number;
}

export interface CardSkuDto {
  /**  */
  title?: string;

  /**  */
  cardId?: number;

  /**  */
  status?: number;

  /**  */
  originPrice?: number;

  /**  */
  price?: number;

  /**  */
  desc?: string;

  /**  */
  durationMonth?: number;

  /**  */
  extensionData?: string;

  /**  */
  card?: MiniCardDto;

  /**  */
  lastSyncTime?: Date;

  /**  */
  id?: number;
}

export interface CardSkuDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CardSkuDto[];
}

export interface CardWithCouponDto {
  /** 会员卡列表 */
  cards?: UserCardDto[];

  /** 优惠券列表 */
  coupons?: CouponDto[];

  /**  */
  userDiffCard?: UserDiffCardDto;
}

export interface ChangePartialAreaToNewBigAreaInput {
  /**  */
  partialAreaId?: number;

  /**  */
  newBigAreaId?: number;
}

export interface ChangePasswordDto {
  /**  */
  currentPassword?: string;

  /**  */
  newPassword?: string;
}

export interface ChangeStoreToNewPartialAreaInput {
  /**  */
  storeId?: number;

  /**  */
  partialAreaId?: number;
}

export interface ChangeUiThemeInput {
  /**  */
  theme?: string;
}

export interface ChangeUserLanguageDto {
  /**  */
  languageName?: string;
}

export interface ClientSettingEditDto {
  /**  */
  wechatMini?: boolean;
}

export interface CmsCategoryCreateOrUpdateDto {
  /**  */
  name?: string;

  /** 栏目编码 */
  categoryCode?: string;

  /** 栏目内容 */
  description?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;
}

export interface CmsCategoryDto {
  /** 栏目名称 */
  name?: string;

  /** 栏目内容 */
  description?: string;

  /** 栏目编码 */
  categoryCode?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  org?: OrganizationUnitShortDto;

  /**  */
  copyFrom?: CopyFrom;

  /**  */
  copyFromId?: number;

  /**  */
  id?: number;
}

export interface CmsCategoryDtoGetForEditOutput {
  /**  */
  data?: CmsCategoryDto;

  /**  */
  schema?: any | null;
}

export interface CmsCategoryDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CmsCategoryDto[];
}

export interface CmsCategoryShortDto {
  /** 栏目名称 */
  name?: string;

  /** 栏目编码 */
  categoryCode?: string;

  /**  */
  id?: number;
}

export interface CmsContentDto {
  /**  */
  categoryId?: number;

  /**  */
  title?: string;

  /**  */
  titleImageUrl?: string;

  /**  */
  content?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  org?: OrganizationUnitShortDto;

  /**  */
  category?: CmsCategoryShortDto;

  /**  */
  status?: CmsContentStatus;

  /** 创建人 */
  createUserName?: string;

  /** 创建时间 */
  creationTime?: Date;

  /**  */
  viewCount?: number;

  /** 存放用户关注等事件 */
  userEvents?: EventTypeEnum[];

  /**  */
  copyFrom?: CopyFrom;

  /**  */
  copyFromId?: number;

  /**  */
  id?: number;
}

export interface CmsContentDtoGetForEditOutput {
  /**  */
  data?: CmsContentDto;

  /**  */
  schema?: any | null;
}

export interface CmsContentDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CmsContentDto[];
}

export interface CommonReserveFundAssignCreateOrEditDto {
  /**  */
  year?: number;

  /**  */
  month?: number;

  /** 姓名 */
  name?: string;

  /**  */
  remark?: string;

  /** 承担金额 */
  amount?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;
}

export interface CommonReserveFundAssignDto {
  /**  */
  year?: number;

  /**  */
  month?: number;

  /** 姓名 */
  name?: string;

  /**  */
  remark?: string;

  /** 承担金额 */
  amount?: number;

  /**  */
  org?: OrganizationUnitShortDto;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  id?: number;
}

export interface CommonReserveFundAssignDtoGetForEditOutput {
  /**  */
  data?: CommonReserveFundAssignDto;

  /**  */
  schema?: any | null;
}

export interface CommonReserveFundAssignDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: CommonReserveFundAssignDto[];
}

export interface CountMonthlyReportDto {
  /**  */
  total?: number;

  /**  */
  values?: Int32MonthlyItem[];
}

export interface Coupon {
  /**  */
  title?: string;

  /**  */
  status?: string;

  /**  */
  price?: number;

  /**  */
  payOrderId?: number;

  /**  */
  userId?: number;

  /**  */
  user?: User;

  /**  */
  hasUsed?: boolean;

  /**  */
  usedTime?: Date;

  /**  */
  usedOrderId?: number;

  /**  */
  usedOrderType?: PayOrderType;

  /**  */
  isDeleted?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  extensionData?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  tenantId?: number;

  /**  */
  domainEvents?: IEventData[];

  /**  */
  id?: number;
}

export interface CouponDto {
  /**  */
  title?: string;

  /**  */
  status?: string;

  /**  */
  price?: number;

  /**  */
  id?: number;
}

export interface CreateOrEditActivityApplyDto {
  /**  */
  activityId?: number;

  /**  */
  babyName?: string;

  /**  */
  realName?: string;

  /**  */
  phone?: string;

  /**  */
  memo?: string;

  /**  */
  id?: number;
}

export interface CreateOrEditActivityDto {
  /**  */
  status?: ActivityStatus;

  /**  */
  title?: string;

  /**  */
  suitableDesc?: string;

  /**  */
  titleImagePath?: string;

  /** 活动开始时间 */
  activityStartTime?: Date;

  /** 活动结束时间 */
  activityEndTime?: Date;

  /** 报名结束时间 */
  applyEndTime?: Date;

  /** 是否限制目标报名人数 */
  isLimitCount?: boolean;

  /** 最大报名人数 */
  maxCount?: number;

  /** 最少报名人数 */
  minCount?: number;

  /**  */
  orginalPrice?: number;

  /**  */
  price?: number;

  /**  */
  placeDetail?: PlaceDetail;

  /**  */
  description?: string;

  /**  */
  auditFlowId?: string;

  /**  */
  id?: number;
}

export interface CreateOrEditActivityDtoGetForEditOutput {
  /**  */
  data?: CreateOrEditActivityDto;

  /**  */
  schema?: any | null;
}

export interface CreateOrEditAuditFlowDto {
  /** 标题 */
  title?: string;

  /** 描述 */
  desc?: string;

  /**  */
  status?: AuditFLowStatus;

  /**  */
  nodesMaxIndex?: number;

  /**  */
  type?: AuditFlowType;

  /** 节点 */
  auditNodes?: CreateOrEditAuditNodeDto[];

  /**  */
  id?: string;
}

export interface CreateOrEditAuditFlowDtoGetForEditOutput {
  /**  */
  data?: CreateOrEditAuditFlowDto;

  /**  */
  schema?: any | null;
}

export interface CreateOrEditAuditNodeDto {
  /**  */
  desc?: string;

  /**  */
  roleName?: string;

  /**  */
  roleId?: number;

  /**  */
  userName?: string;

  /**  */
  userId?: number;

  /**  */
  index?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  tenantId?: number;

  /**  */
  id?: string;
}

export interface CreateOrEditAuditNodePreDefineDto {
  /**  */
  desc?: string;

  /**  */
  roleName?: string;

  /**  */
  roleId?: number;

  /**  */
  userName?: string;

  /**  */
  userId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: string;
}

export interface CreateOrEditAuditNodePreDefineDtoGetForEditOutput {
  /**  */
  data?: CreateOrEditAuditNodePreDefineDto;

  /**  */
  schema?: any | null;
}

export interface CreateOrEditCardDto {
  /**  */
  title?: string;

  /**  */
  titleImageUrl?: string;

  /**  */
  desc?: string;

  /**  */
  ageDesc?: string;

  /**  */
  startTime?: Date;

  /**  */
  endTime?: Date;

  /**  */
  status?: number;

  /**  */
  inventoryNum?: number;

  /**  */
  memberInfo?: string;

  /**  */
  buyInfo?: string;

  /**  */
  cardsTypeInfo?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;
}

export interface CreateOrEditCardDtoGetForEditOutput {
  /**  */
  data?: CreateOrEditCardDto;

  /**  */
  schema?: any | null;
}

export interface CreateOrEditCardSkuDto {
  /** 标题 */
  title?: string;

  /** 状态 */
  status?: number;

  /** 会员卡 */
  cardId?: number;

  /** 原价 */
  originPrice?: number;

  /** 售价 */
  price?: number;

  /** 简介 */
  desc?: string;

  /** 持续时间 */
  durationMonth?: number;

  /**  */
  id?: number;
}

export interface CreateOrEditCardSkuDtoGetForEditOutput {
  /**  */
  data?: CreateOrEditCardSkuDto;

  /**  */
  schema?: any | null;
}

export interface CreateOrEditCmsContentDto {
  /**  */
  categoryId?: number;

  /**  */
  title?: string;

  /**  */
  titleImageUrl?: string;

  /**  */
  content?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  status?: CmsContentStatus;

  /**  */
  id?: number;
}

export interface CreateOrEditDepartmentDto {
  /**  */
  displayName?: string;

  /**  */
  desc?: string;

  /**  */
  parentId?: number;

  /**  */
  index?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;
}

export interface CreateOrEditDepartmentDtoGetForEditOutput {
  /**  */
  data?: CreateOrEditDepartmentDto;

  /**  */
  schema?: any | null;
}

export interface CreateOrEditProjectDto {
  /**  */
  title?: string;

  /**  */
  headmanName?: string;

  /**  */
  headmanPhone?: string;

  /**  */
  headmanMail?: string;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;

  /**  */
  totalBudget?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  id?: number;
}

export interface CreateOrEditProjectDtoGetForEditOutput {
  /**  */
  data?: CreateOrEditProjectDto;

  /**  */
  schema?: any | null;
}

export interface CreateOrEditQuestionDto {
  /**  */
  title?: string;

  /**  */
  status?: number;

  /**  */
  id?: number;
}

export interface CreateOrEditQuestionDtoGetForEditOutput {
  /**  */
  data?: CreateOrEditQuestionDto;

  /**  */
  schema?: any | null;
}

export interface CreateOrEditQuestionTopicDto {
  /**  */
  title?: string;

  /**  */
  questionId?: number;

  /**  */
  order?: number;

  /**  */
  topicContent?: TopicContentItem[];

  /**  */
  id?: number;
}

export interface CreateOrEditQuestionTopicDtoGetForEditOutput {
  /**  */
  data?: CreateOrEditQuestionTopicDto;

  /**  */
  schema?: any | null;
}

export interface CreateOrEditQuestionUserReplyDto {
  /** 调查Id */
  questionId?: number;

  /** 回答内容 */
  questionContent?: QuestionUserReplyTopicItem[];

  /**  */
  id?: number;
}

export interface CreateOrEditUserCardDto {
  /** 宝贝姓名 */
  babyName?: string;

  /** 激活开卡时间 */
  startDate?: Date;

  /** 结束时间 */
  endDate?: Date;

  /**  */
  id?: number;
}

export interface CreateOrEditUserCardDtoGetForEditOutput {
  /**  */
  data?: CreateOrEditUserCardDto;

  /**  */
  schema?: any | null;
}

export interface CreateOrganizationUnitInput {
  /**  */
  id?: number;

  /** 父节点ID */
  parentId?: number;

  /** 显示顺序 */
  displayOrder?: number;

  /** 是否门店 */
  isLeaf?: boolean;

  /**  */
  level?: OrganizationUnitLevel;

  /**  */
  displayName?: string;

  /**  */
  detail?: OrganizationUnitDetailCreateDto;

  /** 商户号 */
  subMchId?: string;

  /** 是否启用服务商模式支付.
<br>为true时，表示使用服务商支付，会付款到门店<br>为false时，表示不使用服务商支付，以成都童萌作为收款方 */
  subPayEnable?: boolean;

  /** 是否为共建机构（加盟商） */
  isAllianceBusiness?: boolean;

  /**  */
  storeType?: StoreType;

  /** 商户主体名称 */
  principalName?: string;

  /**  */
  storeMainType?: StoreMainType;

  /**  */
  defaultSplitByJointOperation?: SplitSetting;

  /**  */
  defaultSplitByPartnership?: SplitSetting;

  /**  */
  defaultSplitByAllianceBusinessSelf?: SplitSetting;

  /**  */
  storeSplitSetting?: SplitSetting;

  /**  */
  cycleSettingInput?: SplitOrderCycleSettingInput;

  /**  */
  splitFeeSetting?: SplitReportSettingInput;
}

export interface CreateOrganizationUnitInputGetForEditOutput {
  /**  */
  data?: CreateOrganizationUnitInput;

  /**  */
  schema?: any | null;
}

export interface CreateOrUpdateInvitationRecordDto {
  /** 被邀请人Id */
  inviteeId?: number;

  /** 分享的会员卡Id */
  cardId?: number;

  /** 折扣比(上限100) */
  rebateRatio?: number;
}

export interface CreateOrUpdateUserInput {
  /**  */
  user?: UserEditDto;

  /**  */
  assignedRoleNames?: string[];
}

export interface CreateRoleDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  normalizedName?: string;

  /**  */
  description?: string;

  /**  */
  grantedPermissions?: string[];

  /**  */
  id?: number;

  /**  */
  isDefault?: boolean;

  /**  */
  isStatic?: boolean;
}

export interface CreateTenantDto {
  /**  */
  tenancyName?: string;

  /**  */
  name?: string;

  /**  */
  adminEmailAddress?: string;

  /**  */
  connectionString?: string;

  /**  */
  isActive?: boolean;
}

export interface CreateUserDto {
  /**  */
  userName?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  emailAddress?: string;

  /**  */
  isActive?: boolean;

  /**  */
  roleNames?: string[];

  /**  */
  password?: string;
}

export interface CreateUserPointLogDto {
  /**  */
  title?: string;

  /**  */
  userId?: number;

  /**  */
  ammount?: number;
}

export interface DataDictionariesCreateOrEditDto {
  /** 键名 */
  key?: string;

  /** 显示的名称 */
  displayName?: string;

  /**  */
  parentId?: number;

  /** 备注 */
  remark?: string;

  /**  */
  tenantId?: number;

  /**  */
  id?: number;
}

export interface DataDictionariesDto {
  /** 键名 */
  key?: string;

  /** 显示的名称 */
  displayName?: string;

  /**  */
  parentId?: number;

  /** 备注 */
  remark?: string;

  /**  */
  id?: number;
}

export interface DataDictionariesDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: DataDictionariesDto[];
}

export interface DecimalMonthlyItem {
  /**  */
  date?: string;

  /**  */
  value?: number;
}

export interface DecimalOrgReportItem {
  /**  */
  orgId?: number;

  /**  */
  orgName?: string;

  /**  */
  value?: number;
}

export interface Department {
  /**  */
  displayName?: string;

  /**  */
  desc?: string;

  /**  */
  parentId?: number;

  /**  */
  index?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  lastModifierUser?: User;

  /**  */
  tenantId?: number;

  /**  */
  extensionData?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnit;

  /**  */
  userDepartments?: UserDepartment[];

  /**  */
  id?: number;
}

export interface DepartmentBaseDto {
  /**  */
  displayName?: string;

  /**  */
  id?: number;
}

export interface DepartmentDto {
  /**  */
  displayName?: string;

  /**  */
  desc?: string;

  /**  */
  parentId?: number;

  /**  */
  index?: number;

  /**  */
  creatorUser?: UserBaseDto;

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /**  */
  users?: UserBaseDto[];

  /**  */
  id?: number;
}

export interface DepartmentDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: DepartmentDto[];
}

export interface EntityDto {
  /**  */
  id?: number;
}

export interface EntityPropertyChangeDto {
  /**  */
  entityChangeId?: number;

  /**  */
  newValue?: string;

  /**  */
  originalValue?: string;

  /**  */
  propertyName?: string;

  /**  */
  propertyTypeFullName?: string;

  /**  */
  tenantId?: number;

  /**  */
  id?: number;
}

export interface ExcelRowImportError {
  /**  */
  errorMessage?: string;

  /**  */
  details?: string[];
}

export interface ExcelRowImportResult {
  /**  */
  model?: any | null;

  /**  */
  success?: boolean;

  /**  */
  error?: ExcelRowImportError;

  /**  */
  rowNumber?: number;

  /**  */
  resultType?: ImportResultType;
}

export interface ExternalAuthenticateModel {
  /**  */
  authProvider?: string;

  /**  */
  providerKey?: string;

  /**  */
  providerAccessCode?: string;

  /**  */
  returnUrl?: string;

  /**  */
  singleSignIn?: boolean;
}

export interface ExternalAuthenticateResultModel {
  /**  */
  accessToken?: string;

  /**  */
  encryptedAccessToken?: string;

  /**  */
  expireInSeconds?: number;

  /**  */
  waitingForActivation?: boolean;

  /**  */
  returnUrl?: string;

  /**  */
  refreshToken?: string;

  /**  */
  refreshTokenExpireInSeconds?: number;

  /**  */
  externalUser?: any | null;
}

export interface ExternalLoginProviderInfoModel {
  /**  */
  name?: string;

  /**  */
  clientId?: string;
}

export interface FillVoucherNumberInput {
  /** 凭证号 */
  voucherNumber?: string;

  /**  */
  id?: number;
}

export interface FindOrganizationUnitUsersInput {
  /**  */
  organizationUnitId?: number;

  /**  */
  maxResultCount?: number;

  /**  */
  skipCount?: number;

  /**  */
  filter?: string;
}

export interface GetCurrentLoginInformationsOutput {
  /**  */
  application?: ApplicationInfoDto;

  /**  */
  user?: UserLoginInfoDto;

  /**  */
  tenant?: TenantLoginInfoDto;

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /**  */
  permissions?: string[];
}

export interface GetNotificationsOutput {
  /**  */
  unreadCount?: number;

  /**  */
  totalCount?: number;

  /**  */
  items?: UserNotification[];
}

export interface GetPersonalCenterStatisticsDto {
  /** 卡券数量 */
  cardAndCouponCount?: number;

  /** 会员卡余额 */
  vipCardBalance?: number;

  /** 积分 */
  point?: number;

  /** 未处理消息数量 */
  notReadMessageCount?: number;
}

export interface GetRoleForEditOutput {
  /**  */
  role?: CreateRoleDto;

  /**  */
  permissions?: PermissionDefinitionDto[];

  /**  */
  grantedPermissionNames?: string[];
}

export interface GetUserForEditOutput {
  /**  */
  headImgUrl?: string;

  /**  */
  user?: UserEditDto;

  /**  */
  roles?: UserRoleDto[];

  /**  */
  allOrganizationUnits?: OrganizationUnitDto[];

  /**  */
  memberedOrganizationUnits?: string[];
}

export interface GuidEntityDto {
  /**  */
  id?: string;
}

export interface HostSettingsEditDto {}

export interface IEventData {
  /**  */
  eventTime?: Date;

  /**  */
  eventSource?: any | null;
}

export interface ImportResult {
  /**  */
  excelFileName?: string;

  /**  */
  importResults?: ExcelRowImportResult[];
}

export interface IncomeRecordCreateOrEditDto {
  /** 收入金额 */
  amount?: number;

  /** 入账日期 */
  incomeDate?: Date;

  /** 备注说明 */
  remark?: string;

  /** 分类ID */
  categoryId?: number;

  /**  */
  id?: number;
}

export interface IncomeRecordCreateOrEditDtoGetForEditOutput {
  /**  */
  data?: IncomeRecordCreateOrEditDto;

  /**  */
  schema?: any | null;
}

export interface IncomeRecordDto {
  /** 收入金额 */
  amount?: number;

  /** 入账日期 */
  incomeDate?: Date;

  /** 备注 */
  remark?: string;

  /** 收入的款项类别id */
  categoryId?: number;

  /**  */
  paymentCategory?: PaymentCategoryDto;

  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface IncomeRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: IncomeRecordDto[];
}

export interface IncomeRecordResultRequestDto {
  /**  */
  sorting?: string;

  /**  */
  amount?: number;

  /** 请求的门店 */
  orgId?: number;

  /** 备注 */
  remark?: string;

  /** 收入的款项类别id */
  categoryId?: number;

  /**  */
  incomeDateStart?: Date;

  /**  */
  incomeDateEnd?: Date;

  /**  */
  amountStart?: number;

  /**  */
  amountEnd?: number;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface IncomeStatisticsCreateOrEditDto {
  /**  */
  year?: number;

  /**  */
  month?: number;

  /**  */
  yearMonth?: string;

  /** 销售额 */
  saleAmount?: number;

  /** 实际销售额 */
  actualSaleAmount?: number;

  /**  */
  remark?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;
}

export interface IncomeStatisticsCreateOrEditDtoGetForEditOutput {
  /**  */
  data?: IncomeStatisticsCreateOrEditDto;

  /**  */
  schema?: any | null;
}

export interface IncomeStatisticsDto {
  /**  */
  year?: number;

  /**  */
  month?: number;

  /**  */
  yearMonth?: string;

  /** 销售额 */
  saleAmount?: number;

  /** 实际销售额 */
  actualSaleAmount?: number;

  /**  */
  remark?: string;

  /**  */
  org?: OrganizationUnitShortDto;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  id?: number;
}

export interface IncomeStatisticsDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: IncomeStatisticsDto[];
}

export interface IncomeSupplementCreateOrUpdateDto {
  /**  */
  displayName?: string;

  /**  */
  category?: IncomeSupplementCategory;

  /**  */
  year?: number;

  /**  */
  month?: number;

  /** 当Category是会员时，此值是必须的 */
  cardId?: number;

  /** 金额 */
  value?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;
}

export interface IncomeSupplementDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  displayName?: string;

  /**  */
  category?: IncomeSupplementCategory;

  /**  */
  year?: number;

  /**  */
  month?: number;

  /** 当Category是会员时，此值是必须的 */
  cardId?: number;

  /** 金额 */
  value?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  id?: number;
}

export interface IncomeSupplementDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: IncomeSupplementDto[];
}

export interface IncomeSupplementPagedResultRequestDto {
  /**  */
  category?: IncomeSupplementCategory;

  /**  */
  year?: number;

  /**  */
  month?: number;

  /**  */
  displayName?: string;

  /**  */
  sorting?: string;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface IndexPageData {
  /**  */
  swipers0?: SwiperDto[];
}

export interface Int32EntityDto {
  /**  */
  id?: number;
}

export interface Int32EntityEventDto {
  /**  */
  eventType?: EventTypeEnum;

  /**  */
  event?: string;

  /**  */
  id?: number;
}

export interface Int32MonthlyItem {
  /**  */
  date?: string;

  /**  */
  value?: number;
}

export interface Int32OrgReportItem {
  /**  */
  orgId?: number;

  /**  */
  orgName?: string;

  /**  */
  value?: number;
}

export interface Int32PayWithCouponInput {
  /**  */
  coupons?: CouponDto[];

  /**  */
  id?: number;
}

export interface Int64EntityDto {
  /**  */
  id?: number;
}

export interface Int64StringKeyValuePair {
  /**  */
  key?: number;

  /**  */
  value?: string;
}

export interface InvitationRecordDto {
  /**  */
  inviteerInfo?: UserDto;

  /**  */
  cardInfo?: CardDto;

  /** 分享的折扣比(上限100) */
  rebateRatio?: number;

  /** 分享成功之后的回调备注(被分享人在注册或者使用会员卡消费之后产生的回调备注信息) */
  successRemark?: string;

  /** 分享成功时间 */
  creationTime?: Date;

  /**  */
  id?: number;
}

export interface InvitationRecordDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: InvitationRecordDto[];
}

export interface IsTenantAvailableInput {
  /**  */
  tenancyName?: string;
}

export interface IsTenantAvailableOutput {
  /**  */
  state?: TenantAvailabilityState;

  /**  */
  tenantId?: number;
}

export interface Location {
  /**  */
  lat?: number;

  /**  */
  lng?: number;
}

export interface MailSettingsEditDto {
  /**  */
  defaultFromAddress?: string;

  /**  */
  defaultFromDisplayName?: string;

  /**  */
  host?: string;

  /**  */
  port?: string;

  /**  */
  userName?: string;

  /**  */
  password?: string;

  /**  */
  domain?: string;

  /**  */
  enableSsl?: string;

  /**  */
  useDefaultCredentials?: string;
}

export interface MiniCardDto {
  /**  */
  title?: string;

  /**  */
  titleImageUrl?: string;

  /**  */
  desc?: string;

  /**  */
  startTime?: Date;

  /**  */
  endTime?: Date;

  /**  */
  baseCardId?: number;

  /**  */
  id?: number;
}

export interface MiniUserDto {
  /**  */
  surname?: string;

  /**  */
  sex?: number;

  /**  */
  birthday?: Date;

  /**  */
  emailAddress?: string;

  /** 登录用户名 */
  userName?: string;

  /** 昵称 */
  name?: string;

  /** 手机 */
  mobilePhone?: string;

  /** 用户头像 */
  headImgUrl?: string;

  /**  */
  id?: number;
}

export interface MoneyMonthlyReportDto {
  /**  */
  total?: number;

  /**  */
  values?: DecimalMonthlyItem[];
}

export interface MoveOrganizationUnitInput {
  /**  */
  id?: number;

  /**  */
  newParentId?: number;
}

export interface MyFavoriteOfActivityDto {
  /**  */
  eventId?: number;

  /**  */
  eventTime?: Date;

  /**  */
  activityId?: number;

  /**  */
  activityTitle?: string;

  /**  */
  activityImage?: string;

  /**  */
  activityStartTime?: Date;

  /**  */
  activityEndTime?: Date;

  /**  */
  applyEndTime?: Date;

  /** 报名成功人次 */
  signUpCount?: number;

  /** 最大报名人数 */
  maxCount?: number;

  /**  */
  place?: string;
}

export interface MyFavoriteOfActivityDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: MyFavoriteOfActivityDto[];
}

export interface MyFavoriteOfCmsContentDto {
  /**  */
  eventId?: number;

  /**  */
  eventTime?: Date;

  /**  */
  cmsContentId?: number;

  /**  */
  cmsContentTitle?: string;

  /**  */
  viewCount?: number;

  /** 文章的创建时间 */
  creationTime?: Date;

  /**  */
  cmsContentTitleImage?: string;
}

export interface MyFavoriteOfCmsContentDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: MyFavoriteOfCmsContentDto[];
}

export interface MyStatisticsDto {
  /** 我的有效的会员卡数量(还可以使用的） */
  vipCardCount?: number;

  /** 我的有效的（未使用的）优惠券的数量 */
  couponCount?: number;

  /** 获取我当前拥有的积分数量 */
  point?: number;

  /** 未读的消息数量 */
  notReadMessageCount?: number;

  /** 我的会员卡的所有余额 */
  vipCardBalanceTotal?: number;
}

export interface NameValueDto {
  /**  */
  name?: string;

  /**  */
  value?: string;
}

export interface NameValueDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: NameValueDto[];
}

export interface NotificationData {
  /**  */
  type?: string;

  /**  */
  properties?: object;
}

export interface NotifySettingEditDto {
  /**  */
  phone?: string;

  /**  */
  newOrderSendStatus?: boolean;

  /**  */
  refundSendStatus?: boolean;

  /**  */
  adminOpenid?: string;
}

export interface OrganizationUnit {
  /**  */
  tenantId?: number;

  /**  */
  parent?: OrganizationUnit;

  /**  */
  parentId?: number;

  /**  */
  code?: string;

  /**  */
  displayName?: string;

  /**  */
  children?: OrganizationUnit[];

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface OrganizationUnitDetail {
  /**  */
  desc?: string;

  /**  */
  logoImgUrl?: string;

  /**  */
  bannerImageUrl?: string;

  /**  */
  address?: string;

  /**  */
  headmanRealName?: string;

  /**  */
  headmanPhone?: string;

  /**  */
  headmanEmail?: string;

  /**  */
  businessHour?: string;

  /**  */
  province?: string;

  /**  */
  city?: string;

  /**  */
  cityId?: number;

  /**  */
  district?: string;

  /**  */
  lng?: number;

  /**  */
  lat?: number;

  /**  */
  bannerImage?: string;

  /**  */
  extensionData?: string;
}

export interface OrganizationUnitDetailCreateDto {
  /**  */
  desc?: string;

  /**  */
  bannerImageUrl?: string;

  /**  */
  logoImgUrl?: string;

  /**  */
  address?: string;

  /**  */
  headmanRealName?: string;

  /**  */
  headmanPhone?: string;

  /**  */
  headmanEmail?: string;

  /** 营业时间 */
  businessHour?: string;

  /** 所属省份 */
  province?: string;

  /** 所属城市 */
  city?: string;

  /** 所属城市ID */
  cityId?: number;

  /** 所属区\/县 */
  district?: string;

  /** 经度 */
  lng?: number;

  /** 纬度 */
  lat?: number;

  /** 是否为共建机构（加盟商） */
  isAllianceBusiness?: boolean;

  /**  */
  storeType?: StoreType;
}

export interface OrganizationUnitDetailDto {
  /**  */
  desc?: string;

  /**  */
  logoImgUrl?: string;

  /**  */
  address?: string;

  /**  */
  headmanRealName?: string;

  /**  */
  headmanPhone?: string;

  /**  */
  headmanEmail?: string;

  /** 营业时间 */
  businessHour?: string;

  /** 所属省份 */
  province?: string;

  /**  */
  bannerImageUrl?: string;

  /** 所属城市 */
  city?: string;

  /** 所属城市ID */
  cityId?: number;

  /** 所属区\/县 */
  istrict?: string;

  /** D
            经度 */
  lng?: number;

  /** 纬度 */
  lat?: number;

  /**  */
  bannerImage?: string;
}

export interface OrganizationUnitDto {
  /**  */
  parentId?: number;

  /**  */
  code?: string;

  /**  */
  status?: number;

  /**  */
  displayOrder?: number;

  /**  */
  level?: OrganizationUnitLevel;

  /**  */
  isLeaf?: boolean;

  /**  */
  displayName?: string;

  /**  */
  memberCount?: number;

  /**  */
  refuseContent?: string;

  /**  */
  detail?: OrganizationUnitDetailDto;

  /** 距离(单位:公里) */
  distance?: number;

  /**  */
  subPayEnable?: boolean;

  /** 商户号 */
  subMchId?: string;

  /**  */
  isActive?: boolean;

  /** 是否启用补差卡 */
  diffCardEnable?: boolean;

  /** 是否为共建机构（加盟商） */
  isAllianceBusiness?: boolean;

  /**  */
  storeType?: StoreType;

  /**  */
  storeMainType?: StoreMainType;

  /** 门店的主体名称 */
  principalName?: string;

  /**  */
  defaultSplitByJointOperation?: SplitSetting;

  /**  */
  defaultSplitByPartnership?: SplitSetting;

  /**  */
  defaultSplitByAllianceBusinessSelf?: SplitSetting;

  /**  */
  storeSplitSetting?: SplitSetting;

  /**  */
  splitFeeSetting?: SplitFeeSetting;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface OrganizationUnitDtoListResultDto {
  /**  */
  items?: OrganizationUnitDto[];
}

export interface OrganizationUnitShortDto {
  /** 名称 */
  displayName?: string;

  /**  */
  parentId?: number;

  /**  */
  id?: number;
}

export interface OrganizationUnitUserListDto {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  userName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  profilePictureId?: string;

  /**  */
  addedTime?: Date;

  /**  */
  departments?: DepartmentBaseDto[];

  /**  */
  id?: number;
}

export interface OrganizationUnitUserListDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: OrganizationUnitUserListDto[];
}

export interface OrganizationWechatUserDto {
  /**  */
  org?: OrganizationUnitShortDto;

  /**  */
  user?: UserDto;

  /**  */
  creationTime?: Date;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;
}

export interface OrganizationWechatUserDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: OrganizationWechatUserDto[];
}

export interface OrgCommentCreateInput {
  /**  */
  organizationUnitId?: number;

  /**  */
  content?: string;
}

export interface OrgCommentDto {
  /**  */
  content?: string;

  /**  */
  isShow?: boolean;

  /**  */
  org?: OrganizationUnitShortDto;

  /**  */
  creatorUser?: UserShortDto;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface OrgCommentDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: OrgCommentDto[];
}

export interface OrgCommentUpdateInput {
  /**  */
  content?: string;

  /**  */
  id?: number;
}

export interface OssSettingEditDto {
  /**  */
  bucketName?: string;

  /**  */
  userName?: string;

  /**  */
  password?: string;

  /**  */
  domainHost?: string;
}

export interface PaymentCategory {
  /**  */
  displayName?: string;

  /**  */
  parentId?: number;

  /**  */
  scope?: PaymentCategoryScope;

  /**  */
  displayOrder?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  lastModifierUser?: User;

  /**  */
  tenantId?: number;

  /**  */
  id?: number;
}

export interface PaymentCategoryCreateOrEditDto {
  /**  */
  displayName?: string;

  /**  */
  parentId?: number;

  /**  */
  scope?: PaymentCategoryScope;

  /**  */
  displayOrder?: number;

  /**  */
  id?: number;
}

export interface PaymentCategoryCreateOrEditDtoGetForEditOutput {
  /**  */
  data?: PaymentCategoryCreateOrEditDto;

  /**  */
  schema?: any | null;
}

export interface PaymentCategoryDto {
  /** 类别名称 */
  displayName?: string;

  /**  */
  parentId?: number;

  /**  */
  displayOrder?: number;

  /**  */
  scope?: PaymentCategoryScope;

  /**  */
  id?: number;
}

export interface PaymentCategoryDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: PaymentCategoryDto[];
}

export interface PayOrderDto {
  /**  */
  body?: string;

  /**  */
  totalPrice?: number;

  /**  */
  billNo?: string;

  /**  */
  openId?: string;

  /**  */
  type?: PayOrderType;

  /**  */
  orderId?: number;

  /**  */
  payType?: PayType;

  /**  */
  isSuccessPay?: boolean;

  /**  */
  successPayTime?: Date;

  /**  */
  refundTime?: Date;

  /**  */
  refundCompletedTime?: Date;

  /**  */
  refundPrice?: number;

  /**  */
  refundedPrice?: number;

  /**  */
  shareFromUserId?: number;

  /**  */
  state?: number;

  /**  */
  fromClient?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  canceledTime?: Date;

  /**  */
  cancelUser?: number;

  /**  */
  cancelReason?: string;

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /**  */
  payUser?: PayUser;

  /**  */
  creationTime?: Date;

  /** 该笔订单是否为分账订单 */
  profitsharing?: boolean;

  /** 微信订单号 */
  wechatTransactionId?: string;

  /** 分账成功后，记录的分账信息id */
  splitBillDetailId?: number;

  /** 子商户号 */
  subMchId?: string;

  /** 是否为服务商模式付款 */
  isSubPay?: boolean;

  /** 订单备注(用户备注) */
  memo?: string;

  /**  */
  babyDetail?: BabyMiniDto;

  /**  */
  id?: number;
}

export interface PayOrderDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: PayOrderDto[];
}

export interface PayOrderResultRequestDto {
  /**  */
  billNo?: string;

  /**  */
  isSuccessPay?: boolean;

  /** Format yyyy-MM */
  yearMonth?: string;

  /**  */
  type?: PayOrderType;

  /**  */
  creatorUserId?: number;

  /**  */
  sorting?: string;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface PayOrderShortDto {
  /**  */
  totalPrice?: number;

  /**  */
  billNo?: string;

  /**  */
  successPayTime?: Date;

  /**  */
  payType?: PayType;

  /**  */
  isSuccessPay?: boolean;

  /**  */
  refundTime?: Date;

  /**  */
  refundCompletedTime?: Date;

  /**  */
  refundPrice?: number;

  /**  */
  refundedPrice?: number;

  /**  */
  creationTime?: Date;

  /**  */
  canceledTime?: Date;

  /**  */
  cancelReason?: string;

  /**  */
  id?: number;
}

export interface PayrollAssignCreateOrEditDto {
  /**  */
  year?: number;

  /**  */
  month?: number;

  /** 姓名 */
  name?: string;

  /** 承担金额 */
  amount?: number;

  /** 备注 */
  remark?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;
}

export interface PayrollAssignDto {
  /**  */
  year?: number;

  /**  */
  month?: number;

  /** 姓名 */
  name?: string;

  /** 承担金额 */
  amount?: number;

  /** 备注 */
  remark?: string;

  /**  */
  org?: OrganizationUnitShortDto;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  id?: number;
}

export interface PayrollAssignDtoGetForEditOutput {
  /**  */
  data?: PayrollAssignDto;

  /**  */
  schema?: any | null;
}

export interface PayrollAssignDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: PayrollAssignDto[];
}

export interface PayrollOfPartnerCreateOrEditDto {
  /** 员工姓名 */
  name?: string;

  /** 年份 */
  year?: number;

  /** 月份 */
  month?: number;

  /** 会员收入 */
  inComeOfVip?: number;

  /** 公司代买物资 */
  behalfBuySuppliesAmount?: number;

  /** 社保 */
  socialSecurity?: number;

  /**  */
  socialSecurityMethod?: SocialSecurityMethod;

  /** 公积金 */
  commonReserveFund?: number;

  /** 退费 */
  returnFee?: number;

  /** 补发工资 */
  backPay?: number;

  /**  */
  remark?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;
}

export interface PayrollOfPartnerDto {
  /**  */
  year?: number;

  /**  */
  month?: number;

  /**  */
  name?: string;

  /** 会员收入 */
  inComeOfVip?: number;

  /** 个人收入的手续费 */
  serviceChargeOfIncome?: number;

  /** 收入小计 */
  incomeOfSubtotal?: number;

  /** 公司管理费 */
  companyManagementFee?: number;

  /** 公司代买物资 */
  behalfBuySuppliesAmount?: number;

  /** 社保 */
  socialSecurity?: number;

  /**  */
  socialSecurityMethod?: SocialSecurityMethod;

  /** 公积金 */
  commonReserveFund?: number;

  /** 退费 */
  returnFee?: number;

  /** 扣除小计 */
  deductedSubtotal?: number;

  /** 补发工资 */
  backPay?: number;

  /** 税前工资 */
  inFrontOfTaxWages?: number;

  /**  */
  remark?: string;

  /**  */
  org?: OrganizationUnitShortDto;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  id?: number;
}

export interface PayrollOfPartnerDtoGetForEditOutput {
  /**  */
  data?: PayrollOfPartnerDto;

  /**  */
  schema?: any | null;
}

export interface PayrollOfPartnerDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: PayrollOfPartnerDto[];
}

export interface PayrollOfSelfCreateOrEditDto {
  /** 姓名 */
  name?: string;

  /** 职务 */
  job?: string;

  /** 年份 */
  year?: number;

  /** 月份 */
  month?: number;

  /** 基本工资 */
  basePayroll?: number;

  /** 工龄费 */
  lengthOfServiceFee?: number;

  /** 私号运营费 */
  selfAccountRun?: number;

  /** 项目补贴 */
  projectSubsidies?: number;

  /** 支持部补贴 */
  supportSubsidies?: number;

  /** 其它补贴 */
  otherSubsidies?: number;

  /** 副教课时费用 */
  teachingAssistantsFee?: number;

  /** 主教课时费用 */
  teachingMainFee?: number;

  /** 绩效 */
  performance?: number;

  /** 缺勤天数 */
  absenteeismDays?: number;

  /** 缺勤扣款 */
  absenteeismAmount?: number;

  /** 社保 */
  socialSecurity?: number;

  /**  */
  socialSecurityMethod?: SocialSecurityMethod;

  /** 公积金 */
  commonReserveFund?: number;

  /** 补发工资 */
  backPay?: number;

  /** 个人所得税 */
  individualIncomeTax?: number;

  /**  */
  remark?: string;

  /**  */
  id?: number;
}

export interface PayrollOfSelfDto {
  /** 姓名 */
  name?: string;

  /** 职务 */
  job?: string;

  /** 年份 */
  year?: number;

  /** 月份 */
  month?: number;

  /** 基本工资 */
  basePayroll?: number;

  /** 工龄费 */
  lengthOfServiceFee?: number;

  /** 私号运营费 */
  selfAccountRun?: number;

  /** 项目补贴 */
  projectSubsidies?: number;

  /** 支持部补贴 */
  supportSubsidies?: number;

  /** 其它补贴 */
  otherSubsidies?: number;

  /** 副教课时费用 */
  teachingAssistantsFee?: number;

  /** 主教课时费用 */
  teachingMainFee?: number;

  /** 绩效 */
  performance?: number;

  /** 缺勤天数 */
  absenteeismDays?: number;

  /** 缺勤扣款 */
  absenteeismAmount?: number;

  /** 应发薪资 */
  shouldSendSalary?: number;

  /** 社保 */
  socialSecurity?: number;

  /**  */
  socialSecurityMethod?: SocialSecurityMethod;

  /** 公积金 */
  commonReserveFund?: number;

  /** 扣除小计 */
  deductedSubtotal?: number;

  /** 补发工资 */
  backPay?: number;

  /** 个人所得税 */
  individualIncomeTax?: number;

  /**  */
  remark?: string;

  /** 实发工资 */
  takeHomePay?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  id?: number;
}

export interface PayrollOfSelfDtoGetForEditOutput {
  /**  */
  data?: PayrollOfSelfDto;

  /**  */
  schema?: any | null;
}

export interface PayrollOfSelfDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: PayrollOfSelfDto[];
}

export interface PayrollRequisition {
  /**  */
  amount?: number;

  /**  */
  summary?: string;

  /**  */
  categoryId?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  lastModifierUser?: User;

  /**  */
  organizationUnitId?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  organizationUnit?: OrganizationUnit;

  /**  */
  auditFlow?: AuditFlow;

  /**  */
  category?: PaymentCategory;

  /**  */
  remark?: string;

  /**  */
  id?: number;
}

export interface PayrollRequisitionAuditLogItem {
  /**  */
  log?: AuditUserLog;

  /**  */
  entity?: PayrollRequisition;
}

export interface PayrollRequisitionCreateOrEditDto {
  /** 请款金额 */
  amount?: number;

  /** 请款说明 */
  summary?: string;

  /** 备注 */
  remark?: string;

  /** 分类ID */
  categoryId?: number;

  /** 凭证的多个附件ID */
  attachments?: string[];

  /**  */
  auditFlowId?: string;

  /**  */
  id?: number;
}

export interface PayrollRequisitionCreateOrEditDtoGetForEditOutput {
  /**  */
  data?: PayrollRequisitionCreateOrEditDto;

  /**  */
  schema?: any | null;
}

export interface PayrollRequisitionDto {
  /** 请款金额 */
  amount?: number;

  /** 请款说明 */
  summary?: string;

  /** 备注 */
  remark?: string;

  /** 分类ID */
  categoryId?: number;

  /**  */
  category?: PaymentCategoryDto;

  /**  */
  organizationUnitId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUser?: UserDto;

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  auditFlow?: AuditFlowDto;

  /**  */
  currentAuditNodes?: AuditNodeDto[];

  /**  */
  id?: number;
}

export interface PayrollRequisitionDtoAuditUserLogDto {
  /**  */
  detail?: PayrollRequisitionDto;

  /**  */
  log?: AuditUserLogDto;
}

export interface PayrollRequisitionDtoAuditUserLogDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: PayrollRequisitionDtoAuditUserLogDto[];
}

export interface PayrollRequisitionDtoListResultDto {
  /**  */
  items?: PayrollRequisitionDto[];
}

export interface PayrollRequisitionDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: PayrollRequisitionDto[];
}

export interface PayrollRequisitionResultRequestDto {
  /**  */
  sorting?: string;

  /**  */
  amount?: number;

  /**  */
  amountStart?: number;

  /**  */
  amountEnd?: number;

  /**  */
  categoryId?: number;

  /**  */
  creationTimeStart?: Date;

  /**  */
  creationTimeEnd?: Date;

  /** 需要审批的状态 */
  audit?: number;

  /** 现在审批的状态 */
  auditStatus?: number;

  /**  */
  organizationUnitId?: string;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface PayUser {
  /**  */
  headImgUrl?: string;

  /**  */
  name?: string;

  /**  */
  birthday?: Date;

  /**  */
  id?: number;
}

export interface PermissionDefinitionCreateOrUpdateDto {
  /** 权限的键 */
  name?: string;

  /** 显示的名称 */
  displayName?: string;

  /**  */
  displayOrder?: number;

  /**  */
  url?: string;

  /**  */
  icon?: string;

  /**  */
  levels?: OrganizationLevel[];

  /**  */
  parentId?: number;

  /**  */
  id?: number;
}

export interface PermissionDefinitionDto {
  /** 权限的键 */
  name?: string;

  /** 显示的名称 */
  displayName?: string;

  /**  */
  url?: string;

  /**  */
  displayOrder?: number;

  /**  */
  icon?: string;

  /**  */
  levels?: OrganizationLevel[];

  /**  */
  parentId?: number;

  /**  */
  id?: number;
}

export interface PermissionDefinitionDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: PermissionDefinitionDto[];
}

export interface PermissionDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  description?: string;

  /**  */
  id?: number;
}

export interface PermissionDtoListResultDto {
  /**  */
  items?: PermissionDto[];
}

export interface PersonalCentersDto {
  /**  */
  userInfo?: UserDto;

  /** 会员卡信息 */
  cardInfo?: Card[];

  /** 不包含已经使用的优惠券信息 */
  couponInfo?: Coupon[];

  /**  */
  id?: number;
}

export interface Place {
  /**  */
  id?: string;

  /**  */
  uid?: string;

  /**  */
  name?: string;

  /**  */
  city?: string;

  /**  */
  cityId?: number;

  /**  */
  district?: string;

  /**  */
  province?: string;

  /**  */
  lat?: number;

  /**  */
  lng?: number;

  /**  */
  location?: Location;
}

export interface PlaceDetail {
  /**  */
  place?: string;

  /**  */
  placeId?: string;

  /**  */
  lng?: number;

  /**  */
  lat?: number;
}

export interface ProfitReportStandardDto {
  /**  */
  value?: number;

  /**  */
  parentId?: string;

  /**  */
  id?: string;

  /**  */
  category?: ProfitCategory;

  /**  */
  itemName?: string;

  /**  */
  month?: number;
}

export interface Project {
  /**  */
  title?: string;

  /**  */
  headmanName?: string;

  /**  */
  headmanPhone?: string;

  /**  */
  headmanMail?: string;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;

  /**  */
  totalBudget?: number;

  /**  */
  projectPaymentsAndReceiptses?: ProjectPaymentsAndReceipts[];

  /**  */
  amountByFirstOfProceeds?: number;

  /**  */
  amountByMiddleOfProceeds?: number;

  /**  */
  amountByEndOfProceeds?: number;

  /**  */
  amountByFirstOfAllotment?: number;

  /**  */
  amountByMiddleOfAllotment?: number;

  /**  */
  amountByEndOfAllotment?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  organizationUnit?: OrganizationUnit;

  /**  */
  auditFlow?: AuditFlow;

  /**  */
  organizationUnitId?: number;

  /**  */
  tenantId?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  lastModifierUser?: User;

  /**  */
  deletionTime?: Date;

  /**  */
  deleterUserId?: number;

  /**  */
  deleterUser?: User;

  /**  */
  extensionData?: string;

  /**  */
  id?: number;
}

export interface ProjectAuditLogItem {
  /**  */
  log?: AuditUserLog;

  /**  */
  entity?: Project;
}

export interface ProjectDto {
  /**  */
  title?: string;

  /**  */
  headmanName?: string;

  /**  */
  headmanPhone?: string;

  /**  */
  headmanMail?: string;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;

  /**  */
  totalBudget?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /** 收款（首期） */
  amountByFirstOfProceeds?: number;

  /** 收款（中期) */
  amountByMiddleOfProceeds?: number;

  /** 收款（尾期) */
  amountByEndOfProceeds?: number;

  /** 拨款（首期） */
  amountByFirstOfAllotment?: number;

  /** 拨款（中期) */
  amountByMiddleOfAllotment?: number;

  /** 拨款（尾期） */
  amountByEndOfAllotment?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  auditFlow?: AuditFlowDto;

  /**  */
  currentAuditNodes?: AuditNodeDto[];

  /**  */
  id?: number;
}

export interface ProjectDtoAuditUserLogDto {
  /**  */
  detail?: ProjectDto;

  /**  */
  log?: AuditUserLogDto;
}

export interface ProjectDtoAuditUserLogDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectDtoAuditUserLogDto[];
}

export interface ProjectDtoListResultDto {
  /**  */
  items?: ProjectDto[];
}

export interface ProjectDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectDto[];
}

export interface ProjectLedgerCreateOrUpdateDto {
  /**  */
  projectId?: number;

  /**  */
  categoryId?: number;

  /** 发生的金额 */
  amount?: number;

  /** 描述 */
  description?: string;

  /** 发生日期 */
  occurrenceDate?: Date;

  /** 项目预算编号 */
  projectBudgetNo?: string;

  /**  */
  id?: number;
}

export interface ProjectLedgerCreateOrUpdateDtoGetForEditOutput {
  /**  */
  data?: ProjectLedgerCreateOrUpdateDto;

  /**  */
  schema?: any | null;
}

export interface ProjectLedgerDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  categoryId?: number;

  /**  */
  category?: PaymentCategoryDto;

  /** 发生的金额 */
  amount?: number;

  /** 描述 */
  description?: string;

  /** 发生日期 */
  occurrenceDate?: Date;

  /** 项目预算编号 */
  projectBudgetNo?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface ProjectLedgerDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectLedgerDto[];
}

export interface ProjectLedgerPagedResultDto {
  /**  */
  projectTitle?: string;

  /**  */
  projectId?: number;

  /**  */
  occurrenceDate?: Date;

  /**  */
  occurrenceDateStart?: Date;

  /**  */
  occurrenceDateEnd?: Date;

  /**  */
  amountStart?: number;

  /**  */
  amountEnd?: number;

  /**  */
  categoryId?: number;

  /** 项目预算编号 */
  projectBudgetNo?: string;

  /**  */
  sorting?: string;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface ProjectPaymentsAndReceipts {
  /**  */
  category?: ProjectPaymentCategory;

  /**  */
  paymentCycleType?: ProjectPaymentCycleType;

  /**  */
  projectId?: number;

  /**  */
  project?: Project;

  /**  */
  amount?: number;

  /**  */
  occurrenceDate?: Date;

  /**  */
  organizationUnitId?: number;

  /**  */
  tenantId?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface ProjectPaymentsAndReceiptsesCreateOrEditDto {
  /**  */
  category?: ProjectPaymentCategory;

  /**  */
  paymentCycleType?: ProjectPaymentCycleType;

  /** 所属项目 */
  projectId?: number;

  /** 发生日期(yyyy-MM-dd) */
  occurrenceDate?: string;

  /** 收款\/拨款 金额 */
  amount?: number;

  /**  */
  id?: number;
}

export interface ProjectPaymentsAndReceiptsesCreateOrEditDtoGetForEditOutput {
  /**  */
  data?: ProjectPaymentsAndReceiptsesCreateOrEditDto;

  /**  */
  schema?: any | null;
}

export interface ProjectPaymentsAndReceiptsesDto {
  /**  */
  category?: ProjectPaymentCategory;

  /**  */
  paymentCycleType?: ProjectPaymentCycleType;

  /** 所属项目 */
  projectId?: number;

  /** 收款\/拨款 金额 */
  amount?: number;

  /**  */
  occurrenceDate?: Date;

  /**  */
  organizationUnitId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUser?: UserDto;

  /**  */
  project?: ProjectDto;

  /**  */
  id?: number;
}

export interface ProjectPaymentsAndReceiptsesDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProjectPaymentsAndReceiptsesDto[];
}

export interface ProjectPaymentsAndReceiptsesResultRequestDto {
  /** 项目名称 */
  projectName?: string;

  /**  */
  category?: ProjectPaymentCategory;

  /**  */
  paymentCycleType?: ProjectPaymentCycleType;

  /** 所属项目 */
  projectId?: number;

  /** 收款\/拨款 金额 */
  amount?: number;

  /**  */
  onlyMe?: boolean;

  /**  */
  organizationUnitId?: number;

  /**  */
  sorting?: string;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface ProtocolCreateUpdateInput {
  /** 协议编号 */
  serialNumber?: string;

  /** 协议名称 */
  displayName?: string;

  /** 签订日期 */
  signingDate?: Date;

  /**  */
  type?: ProtocolType;

  /** 合作周期（单位：年） */
  cooperationPeriod?: number;

  /**  */
  remark?: string;

  /**  */
  savedAttachments?: number[];

  /**  */
  id?: number;
}

export interface ProtocolDto {
  /** 协议编号 */
  serialNumber?: string;

  /** 协议名称 */
  displayName?: string;

  /** 签订日期 */
  signingDate?: Date;

  /** 合作周期（单位：年） */
  cooperationPeriod?: number;

  /**  */
  type?: ProtocolType;

  /**  */
  remark?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  attachments?: AttachmentDto[];

  /**  */
  creatorUser?: UserShortDto;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface ProtocolDtoGetForEditOutput {
  /**  */
  data?: ProtocolDto;

  /**  */
  schema?: any | null;
}

export interface ProtocolDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ProtocolDto[];
}

export interface QuestionDto {
  /**  */
  title?: string;

  /**  */
  accedingCount?: number;

  /**  */
  status?: number;

  /**  */
  creationTime?: Date;

  /**  */
  id?: number;
}

export interface QuestionDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: QuestionDto[];
}

export interface QuestionStatisticsDto {
  /** 问题内容 */
  topicTitle?: string;

  /**  */
  topicId?: number;

  /**  */
  result?: object;
}

export interface QuestionTopicDto {
  /**  */
  title?: string;

  /**  */
  questionId?: number;

  /**  */
  order?: number;

  /**  */
  topicContent?: TopicContentItem[];

  /**  */
  id?: number;
}

export interface QuestionTopicDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: QuestionTopicDto[];
}

export interface QuestionUserReplyDto {
  /** 调查Id */
  questionId?: number;

  /**  */
  questionAnswer?: QuestionUserReplyTopicItem[];

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface QuestionUserReplyDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: QuestionUserReplyDto[];
}

export interface QuestionUserReplyTopicItem {
  /**  */
  key?: string;

  /**  */
  content?: string;
}

export interface RefundDetailDto {
  /**  */
  user?: MiniUserDto;

  /**  */
  wechatUserinfo?: WechatUserinfoDto;

  /**  */
  payOrder?: PayOrderDto;

  /**  */
  refundLog?: RefundLogDto;
}

export interface RefundLog {
  /**  */
  billNo?: string;

  /**  */
  outRefundNo?: string;

  /**  */
  payOrderType?: PayOrderType;

  /**  */
  userId?: number;

  /**  */
  reason?: string;

  /**  */
  price?: number;

  /**  */
  isSuccess?: boolean;

  /**  */
  successTime?: Date;

  /**  */
  creationTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  lastModifierUser?: User;

  /**  */
  creatorUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  isDeleted?: boolean;

  /**  */
  deletionTime?: Date;

  /**  */
  tenantId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnit;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  id?: number;
}

export interface RefundLogAuditLogItem {
  /**  */
  log?: AuditUserLog;

  /**  */
  entity?: RefundLog;
}

export interface RefundLogDto {
  /**  */
  billNo?: string;

  /**  */
  price?: number;

  /**  */
  isSuccess?: boolean;

  /**  */
  successTime?: Date;

  /**  */
  organizationUnitId?: number;

  /**  */
  creationTime?: Date;

  /** 退款原因 */
  reason?: string;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  auditFlow?: AuditFlowDto;

  /**  */
  currentAuditNodes?: AuditNodeDto[];

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /**  */
  payOrderType?: PayOrderType;

  /**  */
  payOrder?: PayOrderDto;

  /**  */
  id?: number;
}

export interface RefundLogDtoAuditUserLogDto {
  /**  */
  detail?: RefundLogDto;

  /**  */
  log?: AuditUserLogDto;
}

export interface RefundLogDtoAuditUserLogDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: RefundLogDtoAuditUserLogDto[];
}

export interface RefundLogDtoListResultDto {
  /**  */
  items?: RefundLogDto[];
}

export interface RefundLogDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: RefundLogDto[];
}

export interface RefundLogResultRequestDto {
  /**  */
  sorting?: string;

  /** 订单号 */
  billNo?: string;

  /** 退款金额（元） */
  price?: number;

  /** 审核状态 */
  auditStatus?: number;

  /** 退款状态 */
  isSuccess?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface RegisterInput {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  userName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  password?: string;

  /**  */
  captchaResponse?: string;
}

export interface RegisterOutput {
  /**  */
  canLogin?: boolean;
}

export interface Reimbursement {
  /**  */
  applicant?: string;

  /**  */
  code?: string;

  /**  */
  amount?: number;

  /**  */
  summary?: string;

  /**  */
  organizationUnit?: OrganizationUnit;

  /**  */
  voucherNumber?: string;

  /**  */
  ticketCount?: number;

  /**  */
  projectBudgetNo?: string;

  /**  */
  projectId?: number;

  /**  */
  project?: Project;

  /**  */
  requestDate?: Date;

  /**  */
  details?: ReimbursementDetail[];

  /**  */
  isDeleted?: boolean;

  /**  */
  organizationUnitId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creatorUser?: User;

  /**  */
  lastModifierUser?: User;

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  id?: number;
}

export interface ReimbursementAuditLogItem {
  /**  */
  log?: AuditUserLog;

  /**  */
  entity?: Reimbursement;
}

export interface ReimbursementCreateOrEditDto {
  /** 报销的申请人 */
  applicant?: string;

  /** 说明 */
  summary?: string;

  /** 报销日期 */
  requestDate?: Date;

  /**  */
  savedAttachments?: number[];

  /** 票据张数 */
  ticketCount?: number;

  /** 项目预算编号 */
  projectBudgetNo?: string;

  /**  */
  projectId?: number;

  /**  */
  details?: ReimbursementDetailCreateOrUpdateDto[];

  /**  */
  organizationUnitId?: number;

  /**  */
  auditFlowId?: string;

  /**  */
  id?: number;
}

export interface ReimbursementCreateOrEditDtoGetForEditOutput {
  /**  */
  data?: ReimbursementCreateOrEditDto;

  /**  */
  schema?: any | null;
}

export interface ReimbursementDetail {
  /**  */
  categoryId?: number;

  /**  */
  paymentCategory?: PaymentCategory;

  /**  */
  amount?: number;

  /**  */
  remark?: string;

  /**  */
  id?: number;
}

export interface ReimbursementDetailCreateOrUpdateDto {
  /**  */
  categoryId?: number;

  /** 报销的金额 */
  amount?: number;

  /**  */
  remark?: string;

  /**  */
  id?: number;
}

export interface ReimbursementDetailDto {
  /**  */
  categoryId?: number;

  /**  */
  paymentCategory?: PaymentCategoryDto;

  /** 报销的金额 */
  amount?: number;

  /**  */
  remark?: string;

  /**  */
  id?: number;
}

export interface ReimbursementDto {
  /**  */
  code?: string;

  /** 报销的申请人 */
  applicant?: string;

  /** 申请报销的金额 */
  amount?: number;

  /** 请款说明 */
  summary?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  projectId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUser?: UserDto;

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /**  */
  project?: ProjectDto;

  /** 凭证号 */
  voucherNumber?: string;

  /** 票据张数 */
  ticketCount?: number;

  /** 项目预算编号 */
  projectBudgetNo?: string;

  /**  */
  details?: ReimbursementDetailDto[];

  /** 报销日期 */
  requestDate?: Date;

  /** 报销单的附件 */
  attachments?: AttachmentDto[];

  /**  */
  auditFlowId?: string;

  /**  */
  audit?: number;

  /**  */
  auditStatus?: number;

  /**  */
  isAudited?: boolean;

  /**  */
  auditFlow?: AuditFlowDto;

  /**  */
  currentAuditNodes?: AuditNodeDto[];

  /**  */
  id?: number;
}

export interface ReimbursementDtoAuditUserLogDto {
  /**  */
  detail?: ReimbursementDto;

  /**  */
  log?: AuditUserLogDto;
}

export interface ReimbursementDtoAuditUserLogDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ReimbursementDtoAuditUserLogDto[];
}

export interface ReimbursementDtoListResultDto {
  /**  */
  items?: ReimbursementDto[];
}

export interface ReimbursementDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: ReimbursementDto[];
}

export interface ReimbursementResultRequestDto {
  /** 报销的申请人 */
  applicant?: string;

  /** 搜索金额 */
  amount?: number;

  /** 最小金额 */
  amountStart?: number;

  /** 最大金额 */
  amountEnd?: number;

  /**  */
  categoryId?: number;

  /** 开始时间 */
  requestDateStart?: Date;

  /** 结束时间 */
  requestDateEnd?: Date;

  /**  */
  organizationUnitId?: string;

  /**  */
  projectId?: number;

  /** 需要审批的状态 */
  audit?: number;

  /** 现在审批的状态 */
  auditStatus?: number;

  /** 凭证号 */
  voucherNumber?: string;

  /** 项目预算编号 */
  projectBudgetNo?: string;

  /**  */
  ticketCount?: number;

  /** 报销的类型.接受的值:project,org */
  type?: string;

  /**  */
  auditFilterType?: AuditFilterType;

  /**  */
  sorting?: string;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface RerunReportCalcInput {
  /**  */
  type?: ProfitType;

  /** 片区\/大区\/门店ID，如果type为总部时，此参数可忽略 */
  orgId?: number;

  /**  */
  year?: number;

  /**  */
  month?: number;
}

export interface ResetPasswordDto {
  /**  */
  adminPassword?: string;

  /**  */
  userId?: number;

  /**  */
  newPassword?: string;
}

export interface RoleDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  normalizedName?: string;

  /**  */
  description?: string;

  /**  */
  grantedPermissions?: string[];

  /**  */
  isDefault?: boolean;

  /**  */
  isStatic?: boolean;

  /**  */
  id?: number;
}

export interface RoleDtoListResultDto {
  /**  */
  items?: RoleDto[];
}

export interface RoleDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: RoleDto[];
}

export interface RoleListDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  isStatic?: boolean;

  /**  */
  isDefault?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  id?: number;
}

export interface RoleListDtoListResultDto {
  /**  */
  items?: RoleListDto[];
}

export interface RoleMiniDto {
  /**  */
  name?: string;

  /**  */
  displayName?: string;

  /**  */
  id?: number;
}

export interface SalaryCreateOrEditDto {
  /** 姓名 */
  name?: string;

  /** 门店\/部门 */
  storeOrDepartment?: string;

  /** 职务 */
  job?: string;

  /**  */
  year?: number;

  /**  */
  month?: number;

  /** 基本工资 */
  basic?: number;

  /** 单位社保 */
  socialSecurityOfUnit?: number;

  /** 单位公积金 */
  providentFundOfUnit?: number;

  /** 绩效 */
  performance?: number;

  /** 课时费 */
  classFee?: number;

  /** 项目补贴 */
  projectSubsidy?: number;

  /** 其他补贴 */
  otherSubsidy?: number;

  /** 缺勤天数 */
  daysLostFromWork?: number;

  /** 扣除金额 */
  deductAmount?: number;

  /** 社区管理费 */
  communityManagementFee?: number;

  /** 手续费 */
  serviceCharge?: number;

  /** 公司管理费 */
  companyManagementFee?: number;

  /** 代买物资 */
  behalfBuySupplies?: number;

  /** 退费金额 */
  refundFeeAmount?: number;

  /** 应发合计 */
  salaryTotal?: number;

  /** 个人社保 */
  otherSocialSecurityOfPersonal?: number;

  /** 单位社保 */
  otherSocialSecurityOfUnit?: number;

  /** 个人公积金 */
  otherProvidentFundOfPersonal?: number;

  /** 单位公积金 */
  otherProvidentFundOfUnit?: number;

  /** 个税 */
  individualIncomeTax?: number;

  /** 实发工资 */
  actualSalary?: number;

  /**  */
  id?: number;
}

export interface SalaryDetailOfOrganizationUnitDto {
  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  categoryId?: number;

  /**  */
  amount?: number;

  /**  */
  category?: PaymentCategoryDto;
}

export interface SalaryDetailOfProjectDto {
  /**  */
  projectId?: number;

  /**  */
  project?: ProjectDto;

  /**  */
  organizationUnitId?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  amount?: number;

  /**  */
  categoryId?: number;

  /**  */
  category?: PaymentCategoryDto;
}

export interface SalaryDto {
  /** 姓名 */
  name?: string;

  /** 门店\/部门 */
  storeOrDepartment?: string;

  /** 职务 */
  job?: string;

  /**  */
  year?: number;

  /**  */
  month?: number;

  /** 基本工资 */
  basic?: number;

  /** 单位社保 */
  socialSecurityOfUnit?: number;

  /** 单位公积金 */
  providentFundOfUnit?: number;

  /** 绩效 */
  performance?: number;

  /** 课时费 */
  classFee?: number;

  /** 项目补贴 */
  projectSubsidy?: number;

  /** 其他补贴 */
  otherSubsidy?: number;

  /** 缺勤天数 */
  daysLostFromWork?: number;

  /** 扣除金额 */
  deductAmount?: number;

  /** 社区管理费 */
  communityManagementFee?: number;

  /** 手续费 */
  serviceCharge?: number;

  /** 公司管理费 */
  companyManagementFee?: number;

  /** 代买物资 */
  behalfBuySupplies?: number;

  /** 退费金额 */
  refundFeeAmount?: number;

  /** 应发合计 */
  salaryTotal?: number;

  /** 个人社保 */
  otherSocialSecurityOfPersonal?: number;

  /** 单位社保 */
  otherSocialSecurityOfUnit?: number;

  /** 个人公积金 */
  otherProvidentFundOfPersonal?: number;

  /** 单位公积金 */
  otherProvidentFundOfUnit?: number;

  /** 个税 */
  individualIncomeTax?: number;

  /** 实发工资 */
  actualSalary?: number;

  /**  */
  organizationUnit?: OrganizationUnitShortDto;

  /**  */
  salaryDetailOfOrganizationUnits?: SalaryDetailOfOrganizationUnitDto[];

  /**  */
  salaryDetailOfProjects?: SalaryDetailOfProjectDto[];

  /**  */
  id?: number;
}

export interface SalaryDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: SalaryDto[];
}

export interface SalaryPagedResultDto {
  /**  */
  name?: string;

  /**  */
  job?: string;

  /**  */
  year?: number;

  /**  */
  month?: number;

  /**  */
  sorting?: string;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface ScanInput {
  /**  */
  scanType?: ScanType;

  /**  */
  path?: string;

  /**  */
  result?: string;
}

export interface Setting {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  name?: string;

  /**  */
  value?: string;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface SocialSecurityAssignCreateOrEditDto {
  /**  */
  year?: number;

  /**  */
  month?: number;

  /** 姓名 */
  name?: string;

  /**  */
  remark?: string;

  /** 承担金额 */
  amount?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  id?: number;
}

export interface SocialSecurityAssignDto {
  /**  */
  year?: number;

  /**  */
  month?: number;

  /** 姓名 */
  name?: string;

  /**  */
  remark?: string;

  /** 承担金额 */
  amount?: number;

  /**  */
  org?: OrganizationUnitShortDto;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  id?: number;
}

export interface SocialSecurityAssignDtoGetForEditOutput {
  /**  */
  data?: SocialSecurityAssignDto;

  /**  */
  schema?: any | null;
}

export interface SocialSecurityAssignDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: SocialSecurityAssignDto[];
}

export interface SplitAccountFeeDisplayConfigureDto {
  /**  */
  fee1DisplayName?: string;

  /**  */
  fee2DisplayName?: string;

  /**  */
  fee3DisplayName?: string;
}

export interface SplitBillDetailDto {
  /**  */
  payOrder?: PayOrderShortDto;

  /**  */
  billId?: number;

  /**  */
  bill?: SplitBillShortDto;

  /** 订单实付金额 */
  orderPayedAmount?: number;

  /** 门店分账所得金额 */
  storeReceivedAmount?: number;

  /** 门店的微信支付商户号 */
  storeMchId?: string;

  /** 共建机构（加盟商）分账所得总金额 */
  allianceBusinessReceivedAmount?: number;

  /** 共建机构（加盟商）分账的账户 */
  allianceBusinessMchId?: string;

  /** 平台分账所得金额 */
  platformReceivedAmount?: number;

  /** 分给平台账户的微信支付商户号 */
  platformMchId?: string;

  /** 微信订单号 */
  transactionId?: string;

  /** 商户侧分账单号 */
  outOrderNo?: string;

  /** 微信分账单号.
微信分账成功时记录的微信分账单号 */
  wechatSplitOrderId?: string;

  /**  */
  creationTime?: Date;

  /** 分账单状态
PROCESSING
FINISHED */
  status?: string;

  /** 分账完成时间 */
  successTime?: Date;

  /** 累计退款金额，单位：分 */
  refundAmount?: number;

  /**  */
  returnSuccessTime?: Date;

  /** 失败原因 */
  failReason?: string;

  /**  */
  isApiError?: boolean;

  /** 是否为连锁品牌分账模式 */
  isBrandProfitSharing?: boolean;

  /**  */
  id?: number;
}

export interface SplitBillDetailDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: SplitBillDetailDto[];
}

export interface SplitBillDto {
  /**  */
  endDate?: Date;

  /** 本期账单中，订单的总金额.单位：分 */
  totalAmount?: number;

  /** 门店分账所得金额。单位：分 */
  storeReceivedAmount?: number;

  /** 门店的分账比例 */
  storePercent?: number;

  /** 共建机构（加盟商）分账所得总金额 */
  allianceBusinessReceivedAmount?: number;

  /** 共建机构（加盟商）的分账比例 */
  allianceBusinessPercent?: number;

  /** 平台分账所得总金额.单位：分 */
  platformReceivedAmount?: number;

  /** 平台分账比例 */
  platformPercent?: number;

  /** 此次计划分账的订单总数量 */
  totalOrderCount?: number;

  /** 分账成功的订单总数量 */
  successOrderCount?: number;

  /** 共建机构（加盟商）ID
其实也就是OrganizationUnitId
只有当该门店运营属性属于联营时，才会将账单抄送至共建机构（加盟商） */
  allianceBusinessId?: number;

  /** 账单日期(yyyy-MM-dd) */
  billDate?: string;

  /** 处理的批次号 */
  batchNo?: string;

  /**  */
  store?: OrganizationUnitShortDto;

  /**  */
  partialAreaOrg?: OrganizationUnitShortDto;

  /**  */
  creationTime?: Date;

  /**  */
  organizationUnitId?: number;

  /** 微信手续费比例 */
  wechatFeePercent?: number;

  /**  */
  id?: number;
}

export interface SplitBillDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: SplitBillDto[];
}

export interface SplitBillReturnDetailDto {
  /** 子商户号. 分账回退的接收商户，对应原分账出资的分账方商户 */
  subMchId?: string;

  /** 回退商户号.
只能填写原分账请求中接收分账的商户号 */
  returnMchId?: string;

  /** 商户侧回退单号 */
  outReturnNo?: string;

  /** 微信回退单号 */
  wechatReturnNo?: string;

  /** 回退金额(分） */
  amount?: number;

  /**  */
  type?: SplitReceiverType;

  /** 回退结果.
如果请求返回为处理中，则商户可以通过调用回退结果查询接口获取请求的最终处理结果，枚举值：
PROCESSING：处理中
SUCCESS：已成功
 FAILED：已失败
 如果返回为处理中，请勿变更商户回退单号，使用相同的参数再次发起分账回退，否则会出现资金风险 在处理中状态的回退单如果5天没有成功，会因为超时被设置为已失败 */
  result?: string;

  /** 失败原因 */
  failReason?: string;

  /** 完成时间 */
  finishTime?: Date;

  /**  */
  creationTime?: Date;

  /**  */
  id?: number;
}

export interface SplitBillReturnDto {
  /** 用户退款金额，单位：分 */
  refundAmount?: number;

  /** 门店承担的金额,单位:分 */
  storeCoverAmount?: number;

  /** 平台承担的金额,单位:分 */
  platformCoverAmount?: number;

  /** 共建机构（加盟商）承担的金额,单位:分 */
  allianceBusinessCovertAmount?: number;

  /** 是否全部回退成功 */
  isSuccess?: boolean;

  /** 全部完成时间 */
  finishTime?: Date;

  /**  */
  creationTime?: Date;

  /**  */
  details?: SplitBillReturnDetailDto[];

  /**  */
  id?: number;
}

export interface SplitBillShortDto {
  /** 本次账单分账的结束时间点 */
  endDate?: Date;

  /** 账单日期(yyyy-MM-dd) */
  billDate?: string;

  /** 处理的批次号 */
  batchNo?: string;

  /**  */
  creationTime?: Date;

  /** 本期账单中，订单的总金额.单位：分 */
  totalAmount?: number;

  /** 门店分账所得金额。单位：分 */
  storeReceivedAmount?: number;

  /** 门店的分账比例 */
  storePercent?: number;

  /** 共建机构（加盟商）分账所得总金额 */
  allianceBusinessReceivedAmount?: number;

  /** 共建机构（加盟商）的分账比例 */
  allianceBusinessPercent?: number;

  /** 平台分账所得总金额.单位：分 */
  platformReceivedAmount?: number;

  /** 平台分账比例 */
  platformPercent?: number;

  /** 门店ID */
  organizationUnitId?: number;

  /**  */
  store?: OrganizationUnitShortDto;

  /**  */
  id?: number;
}

export interface SplitBillStatisticsDto {
  /**  */
  billDate?: string;

  /** 订单总数量 */
  orderCount?: number;

  /** 订单总金额 */
  totalAmount?: number;

  /** 退款金额 */
  refundAmount?: number;

  /** 门店实际收入 */
  storeReceivedAmount?: number;

  /** 共建机构（加盟商）实际收入 */
  allianceBusinessAmount?: number;

  /** 微信手续费比例 */
  wechatFeePercent?: number;
}

export interface SplitFeeSetting {
  /**  */
  fee1?: number;

  /**  */
  fee2?: number;

  /**  */
  fee3?: number;

  /**  */
  splitPercentOfPartialArea?: number;

  /**  */
  splitPercentOfStore?: number;

  /**  */
  remark?: string;
}

export interface SplitOrderCycleSettingInput {
  /**  */
  cycleType?: SplitOrderCycleType;

  /**  */
  values?: string;
}

export interface SplitReportSettingInput {
  /** 固定费用1 */
  fee1?: number;

  /** 固定费用2 */
  fee2?: number;

  /** 固定费用3 */
  fee3?: number;

  /** 分账给片区(共建机构)的比例，单位：% */
  splitPercentOfPartialArea?: number;

  /** 分账给门店(合伙人)的比例，单位：% */
  splitPercentOfStore?: number;

  /** 分账的描述 */
  remark?: string;
}

export interface SplitSetting {
  /**  */
  toTongMeng?: number;

  /**  */
  toStore?: number;

  /**  */
  toAllianceBusiness?: number;

  /**  */
  isEmpty?: boolean;
}

export interface StoreSplitAccountReportChangeInput {
  /**  */
  remark?: string;

  /**  */
  fee1?: number;

  /**  */
  fee2?: number;

  /**  */
  fee3?: number;

  /**  */
  id?: string;
}

export interface StoreSplitAccountReportDto {
  /** 年 */
  year?: number;

  /** 月 */
  month?: number;

  /** 门店Id */
  storeId?: number;

  /** 门店名称 */
  storeName?: string;

  /**  */
  storeDisplayOrder?: number;

  /**  */
  storeType?: StoreType;

  /** 片区Id */
  partialAreaId?: number;

  /** 片区名称 */
  partialAreaName?: string;

  /**  */
  partialAreaDisplayOrder?: number;

  /**  */
  bigAreaId?: number;

  /**  */
  bigAreaName?: string;

  /**  */
  bigAreaDisplayOrder?: number;

  /** 分账的公式说明 */
  remark?: string;

  /** 门店营收收入 */
  income?: number;

  /** 固定费用1 */
  fee1?: number;

  /**  */
  fee1DisplayName?: string;

  /** 固定费用2 */
  fee2?: number;

  /**  */
  fee2DisplayName?: string;

  /** 固定费用3 */
  fee3?: number;

  /**  */
  fee3DisplayName?: string;

  /** 门店分账比例 */
  storeSplitPercent?: number;

  /** 片区分账比例 */
  partialAreaSplitPercent?: number;

  /** 分账给门店的金额 */
  splitAmountToStore?: number;

  /** 分账给片区(共建机构\/合伙人)的金额 */
  splitAmountToPartialArea?: number;

  /** 分账给总部(童萌)的金额 */
  splitAmountToHeadquarters?: number;

  /**  */
  id?: string;
}

export interface StoreSplitAccountReportFeeChangeHistoryDto {
  /**  */
  fee1?: number;

  /**  */
  fee2?: number;

  /**  */
  fee3?: number;

  /**  */
  remark?: string;

  /**  */
  fee1_Before?: number;

  /**  */
  fee2_Before?: number;

  /**  */
  fee3_Before?: number;

  /**  */
  remark_Before?: string;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  creatorUser?: UserShortDto;

  /**  */
  id?: string;
}

export interface StoreYearlyCardSaleReportCardItemDto {
  /**  */
  cardId?: number;

  /**  */
  cardName?: string;

  /**  */
  baseCardId?: number;

  /**  */
  monthlyValues?: StoreYearlyCardSaleReportMonthlyItemDto[];
}

export interface StoreYearlyCardSaleReportDto {
  /**  */
  items?: StoreYearlyCardSaleReportItemDto[];
}

export interface StoreYearlyCardSaleReportItemDto {
  /**  */
  storeId?: number;

  /**  */
  storeName?: string;

  /**  */
  cardSales?: StoreYearlyCardSaleReportCardItemDto[];
}

export interface StoreYearlyCardSaleReportMonthlyItemDto {
  /** 实际销售金额 */
  amount?: number;

  /** 月份 */
  month?: number;
}

export interface StoreYearlySaleReportDto {
  /**  */
  items?: StoreYearlySaleReportItemDto[];
}

export interface StoreYearlySaleReportItemDto {
  /**  */
  storeId?: number;

  /**  */
  storeName?: string;

  /**  */
  monthlyValues?: StoreYearlySaleReportMonthlyItemDto[];
}

export interface StoreYearlySaleReportMonthlyItemDto {
  /** 实际销售金额 */
  amount?: number;

  /** 月份 */
  month?: number;
}

export interface StringStringKeyValuePair {
  /**  */
  key?: string;

  /**  */
  value?: string;
}

export interface SubscribeInput {
  /**  */
  ticket?: string;
}

export interface SwiperDto {
  /**  */
  groupId?: number;

  /**  */
  swiperType?: number;

  /**  */
  imagePath?: string;

  /**  */
  title?: string;

  /**  */
  url?: string;

  /**  */
  organizationUnitId?: number;

  /**  */
  copyFrom?: CopyFrom;

  /**  */
  copyFromId?: number;

  /**  */
  id?: number;
}

export interface SwiperDtoGetForEditOutput {
  /**  */
  data?: SwiperDto;

  /**  */
  schema?: any | null;
}

export interface SwiperDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: SwiperDto[];
}

export interface TenantDto {
  /**  */
  tenancyName?: string;

  /**  */
  name?: string;

  /**  */
  isActive?: boolean;

  /**  */
  id?: number;
}

export interface TenantDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: TenantDto[];
}

export interface TenantLoginInfoDto {
  /**  */
  tenancyName?: string;

  /**  */
  name?: string;

  /**  */
  id?: number;
}

export interface TenantNotification {
  /**  */
  tenantId?: number;

  /**  */
  notificationName?: string;

  /**  */
  data?: NotificationData;

  /**  */
  entityType?: string;

  /**  */
  entityTypeName?: string;

  /**  */
  entityId?: any | null;

  /**  */
  severity?: NotificationSeverity;

  /**  */
  creationTime?: Date;

  /**  */
  id?: string;
}

export interface TenantSettingsEditDto {
  /**  */
  oss?: OssSettingEditDto;

  /**  */
  client?: ClientSettingEditDto;

  /**  */
  notify?: NotifySettingEditDto;
}

export interface TopicContentItem {
  /**  */
  key?: string;

  /**  */
  content?: string;
}

export interface UpdateOrganizationUnitInput {
  /**  */
  id?: number;

  /**  */
  displayName?: string;

  /**  */
  isLeaf?: boolean;

  /** 显示顺序 */
  displayOrder?: number;

  /**  */
  level?: OrganizationUnitLevel;

  /**  */
  detail?: OrganizationUnitDetailCreateDto;

  /** 商户号 */
  subMchId?: string;

  /** 分账比例 */
  splitPercent?: number;

  /** 是否为共建机构（加盟商） */
  isAllianceBusiness?: boolean;

  /**  */
  storeType?: StoreType;

  /** 商户主体名称 */
  principalName?: string;

  /**  */
  storeMainType?: StoreMainType;

  /** 是否启用服务商模式支付.
<br>为true时，表示使用服务商支付，会付款到门店<br>为false时，表示不使用服务商支付，以成都童萌作为收款方 */
  subPayEnable?: boolean;

  /**  */
  defaultSplitByJointOperation?: SplitSetting;

  /**  */
  defaultSplitByPartnership?: SplitSetting;

  /**  */
  defaultSplitByAllianceBusinessSelf?: SplitSetting;

  /**  */
  storeSplitSetting?: SplitSetting;

  /**  */
  cycleSettingInput?: SplitOrderCycleSettingInput;

  /**  */
  splitFeeSetting?: SplitReportSettingInput;
}

export interface UpdateSplitOrderBillReceiversInput {
  /**  */
  receivers?: string[];
}

export interface UpdateUserCardEndDateInput {
  /**  */
  endDate?: Date;

  /**  */
  id?: number;
}

export interface UploadResult {
  /**  */
  hostType?: AttachmentHostType;

  /**  */
  attachmentId?: number;

  /**  */
  fileName?: string;

  /**  */
  url?: string;
}

export interface User {
  /**  */
  headImgUrl?: string;

  /**  */
  point?: number;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  birthday?: Date;

  /**  */
  fromClient?: ClientType;

  /**  */
  organizationUnits?: UserOrganizationUnit[];

  /**  */
  babyDetail?: UserBabyDetail;

  /**  */
  oidcDetail?: UserOidcDetail;

  /**  */
  userDepartments?: UserDepartment[];

  /**  */
  normalizedUserName?: string;

  /**  */
  normalizedEmailAddress?: string;

  /**  */
  concurrencyStamp?: string;

  /**  */
  tokens?: UserToken[];

  /**  */
  deleterUser?: User;

  /**  */
  creatorUser?: User;

  /**  */
  lastModifierUser?: User;

  /**  */
  authenticationSource?: string;

  /**  */
  userName?: string;

  /**  */
  tenantId?: number;

  /**  */
  emailAddress?: string;

  /**  */
  fullName?: string;

  /**  */
  password?: string;

  /**  */
  emailConfirmationCode?: string;

  /**  */
  passwordResetCode?: string;

  /**  */
  lockoutEndDateUtc?: Date;

  /**  */
  accessFailedCount?: number;

  /**  */
  isLockoutEnabled?: boolean;

  /**  */
  phoneNumber?: string;

  /**  */
  isPhoneNumberConfirmed?: boolean;

  /**  */
  securityStamp?: string;

  /**  */
  isTwoFactorEnabled?: boolean;

  /**  */
  logins?: UserLogin[];

  /**  */
  roles?: UserRole[];

  /**  */
  claims?: UserClaim[];

  /**  */
  permissions?: UserPermissionSetting[];

  /**  */
  settings?: Setting[];

  /**  */
  isEmailConfirmed?: boolean;

  /**  */
  isActive?: boolean;

  /**  */
  isDeleted?: boolean;

  /**  */
  deleterUserId?: number;

  /**  */
  deletionTime?: Date;

  /**  */
  lastModificationTime?: Date;

  /**  */
  lastModifierUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface UserAuthorizeAccessTokenResultDto {
  /**  */
  access_token?: string;

  /**  */
  refresh_token?: string;

  /**  */
  expires_in?: number;

  /**  */
  openid?: string;

  /**  */
  scope?: string;

  /**  */
  errcode?: number;

  /**  */
  errmsg?: string;

  /**  */
  isSuccess?: boolean;
}

export interface UserBabyDetail {
  /**  */
  realname?: string;

  /**  */
  sex?: SexEnum;

  /**  */
  birthday?: Date;

  /**  */
  nickname?: string;

  /**  */
  contactName?: string;

  /**  */
  contactDesc?: string;

  /**  */
  contactPhone?: string;

  /**  */
  babySummary?: string;

  /**  */
  place?: string;

  /**  */
  lng?: number;

  /**  */
  lat?: number;

  /**  */
  shareQrPath?: string;
}

export interface UserBabyDetailEditDto {
  /**  */
  realname?: string;

  /**  */
  sex?: SexEnum;

  /**  */
  birthday?: Date;

  /**  */
  nickname?: string;

  /**  */
  contactName?: string;

  /**  */
  contactDesc?: string;

  /**  */
  contactPhone?: string;

  /**  */
  babySummary?: string;

  /**  */
  place?: string;

  /**  */
  lng?: number;

  /**  */
  lat?: number;

  /**  */
  shareQrPath?: string;
}

export interface UserBaseDto {
  /** 登录用户名 */
  userName?: string;

  /** 昵称 */
  name?: string;

  /** 用户姓名 */
  surname?: string;

  /** 手机 */
  mobilePhone?: string;

  /** 用户头像 */
  headImgUrl?: string;

  /**  */
  id?: number;
}

export interface UserBaseDtoListResultDto {
  /**  */
  items?: UserBaseDto[];
}

export interface UserCardDeductionInput {
  /**  */
  billNo?: string;

  /**  */
  period?: string;

  /**  */
  ammount?: number;

  /**  */
  desc?: string;

  /**  */
  userId?: number;

  /**  */
  userCardId?: number;
}

export interface UserCardDto {
  /**  */
  billNo?: string;

  /**  */
  status?: UserCardStatus;

  /**  */
  babyName?: string;

  /**  */
  title?: string;

  /**  */
  startDate?: Date;

  /**  */
  endDate?: Date;

  /**  */
  totalPrice?: number;

  /**  */
  balance?: number;

  /**  */
  payMchId?: string;

  /**  */
  card?: MiniCardDto;

  /**  */
  cardSku?: CardSkuDto;

  /**  */
  organizationUnit?: OrganizationUnitDto;

  /**  */
  creatorUserId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  id?: number;
}

export interface UserCardDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: UserCardDto[];
}

export interface UserCardLogDto {
  /**  */
  billNo?: string;

  /**  */
  type?: UserCardLogType;

  /**  */
  desc?: string;

  /** 扣费周期 */
  period?: string;

  /** 扣除金额 */
  ammount?: number;

  /**  */
  creationTime?: Date;

  /**  */
  userCard?: UserCardDto;

  /**  */
  id?: number;
}

export interface UserClaim {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  claimType?: string;

  /**  */
  claimValue?: string;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface UserDepartment {
  /**  */
  departmentId?: number;

  /**  */
  userId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  tenantId?: number;

  /**  */
  user?: User;

  /**  */
  department?: Department;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface UserDiffCardDto {
  /**  */
  balance?: number;
}

export interface UserDiffCardRefundInput {
  /**  */
  orderId?: number;

  /** 要退款的金额 */
  amount?: number;

  /** 退款审批流程 */
  auditFlowId?: string;

  /** 退款原因 */
  desc?: string;
}

export interface UserDto {
  /**  */
  userName?: string;

  /** 存放用户昵称 */
  name?: string;

  /** 生日 */
  birthday?: Date;

  /**  */
  headImgUrl?: string;

  /** 存放用户姓名 */
  surname?: string;

  /**  */
  emailAddress?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  isActive?: boolean;

  /**  */
  fullName?: string;

  /**  */
  lastLoginTime?: Date;

  /**  */
  creationTime?: Date;

  /**  */
  point?: number;

  /**  */
  roleNames?: string[];

  /** 会员卡的余额 */
  vipCardBalance?: number;

  /** 补差卡的余额 */
  diffCardBalance?: number;

  /**  */
  babyDetail?: UserBabyDetail;

  /**  */
  id?: number;
}

export interface UserDtoBase {
  /**  */
  userName?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  id?: number;
}

export interface UserDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: UserDto[];
}

export interface UserEditDto {
  /** Set null to create a new user. Set user's Id to update a user */
  id?: number;

  /**  */
  userName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  headImgUrl?: string;

  /**  */
  sex?: number;

  /**  */
  brithday?: Date;

  /**  */
  phoneNumber?: string;

  /**  */
  password?: string;

  /**  */
  isActive?: boolean;

  /**  */
  babyDetail?: UserBabyDetail;
}

export interface UserHoldCardInfoDto {
  /**  */
  cardId?: number;

  /**  */
  cardTypeId?: number;

  /**  */
  storeId?: number;

  /**  */
  card?: CardDto;
}

export interface UserHoldCardInfoDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: UserHoldCardInfoDto[];
}

export interface UserLogin {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  loginProvider?: string;

  /**  */
  providerKey?: string;

  /**  */
  id?: number;
}

export interface UserLoginInfoDto {
  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  userName?: string;

  /**  */
  emailAddress?: string;

  /**  */
  isSubscribe?: boolean;

  /**  */
  headImgUrl?: string;

  /**  */
  roles?: string[];

  /**  */
  id?: number;
}

export interface UserNotification {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  state?: UserNotificationState;

  /**  */
  notification?: TenantNotification;

  /**  */
  targetNotifiers?: string;

  /**  */
  targetNotifiersList?: string[];

  /**  */
  id?: string;
}

export interface UserOidcDetail {
  /**  */
  weChatMiniOpenId?: string;

  /**  */
  weChatOpenId?: string;

  /**  */
  weChatUnionId?: string;
}

export interface UserOrganizationUnit {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  organizationUnitId?: number;

  /**  */
  isDeleted?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface UserPageData {
  /** 优惠券数量 */
  conponCount?: number;

  /** 会员卡数量 */
  cardCount?: number;

  /**  */
  pointCount?: number;

  /**  */
  messageUnRead?: number;
}

export interface UserPagedResultDto {
  /** UserName , Name ,EmailAddress */
  keyword?: string;

  /** 宝贝姓名 */
  babyName?: string;

  /** 宝贝昵称 */
  babyNickName?: string;

  /** 宝贝联系人姓名 */
  contactName?: string;

  /**  */
  isActive?: boolean;

  /** 是否获取用户的会员卡的余额 */
  isGetUserVipCardBalance?: boolean;

  /** 是否获取用户的补差卡余额 */
  isGetUserDiffCardBalance?: boolean;

  /**  */
  sorting?: string;

  /**  */
  skipCount?: number;

  /**  */
  maxResultCount?: number;
}

export interface UserPermissionSetting {
  /**  */
  userId?: number;

  /**  */
  tenantId?: number;

  /**  */
  name?: string;

  /**  */
  isGranted?: boolean;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface UserPointLogDto {
  /**  */
  title?: string;

  /**  */
  userId?: number;

  /**  */
  ammount?: number;

  /**  */
  oldPoints?: number;

  /**  */
  newPoints?: number;

  /**  */
  creationTime?: Date;

  /**  */
  user?: User;

  /**  */
  id?: number;
}

export interface UserPointLogDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: UserPointLogDto[];
}

export interface UserProfileInput {
  /**  */
  userName?: string;

  /**  */
  name?: string;

  /**  */
  surname?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  isPhoneNumberConfirmed?: boolean;

  /**  */
  emailAddress?: string;

  /**  */
  password?: string;

  /**  */
  passwordConfirm?: string;
}

export interface UserRole {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  roleId?: number;

  /**  */
  creationTime?: Date;

  /**  */
  creatorUserId?: number;

  /**  */
  id?: number;
}

export interface UserRoleDto {
  /**  */
  roleId?: number;

  /**  */
  roleName?: string;

  /**  */
  roleDisplayName?: string;

  /**  */
  isAssigned?: boolean;
}

export interface UserShortDto {
  /** 头像 */
  headImgUrl?: string;

  /** 昵称 */
  name?: string;

  /**  */
  nickName?: string;

  /**  */
  id?: number;
}

export interface UsersToOrganizationUnitInput {
  /**  */
  userIds?: number[];

  /**  */
  organizationUnitId?: number;

  /**  */
  departmentId?: number;
}

export interface UserToken {
  /**  */
  tenantId?: number;

  /**  */
  userId?: number;

  /**  */
  loginProvider?: string;

  /**  */
  name?: string;

  /**  */
  value?: string;

  /**  */
  expireDate?: Date;

  /**  */
  id?: number;
}

export interface WeChatMiniProgramAuthenticateModel {
  /**  */
  code?: string;

  /**  */
  encryptedData?: string;

  /**  */
  iv?: string;

  /**  */
  session_key?: string;

  /**  */
  scene?: string;

  /**  */
  isSceneOfShare?: boolean;
}

export interface WechatUserinfoDto {
  /**  */
  id?: string;

  /**  */
  openid?: string;

  /**  */
  unionid?: string;

  /**  */
  nickname?: string;

  /**  */
  headimgurl?: string;

  /**  */
  city?: string;

  /**  */
  province?: string;

  /**  */
  country?: string;

  /**  */
  fromClient?: string;

  /**  */
  sex?: number;
}

export interface WechatUserinfoDtoPagedResultDto {
  /**  */
  totalCount?: number;

  /**  */
  items?: WechatUserinfoDto[];
}

export interface WxPayResult {
  /**  */
  id?: number;

  /**  */
  billNo?: string;

  /**  */
  appid?: string;

  /**  */
  timeStamp?: string;

  /**  */
  nonceStr?: string;

  /**  */
  prepay_id?: string;

  /**  */
  signType?: string;

  /**  */
  paySign?: string;
}

export enum ActivityApplyStatus {
  'Auditing' = 'Auditing',
  'Reject' = 'Reject',
  'Refunding' = 'Refunding',
  'Payed' = 'Payed',
  'NotPay' = 'NotPay',
  'Approved' = 'Approved',
  'CheckOut' = 'CheckOut',
  'Refunded' = 'Refunded',
  'Canceled' = 'Canceled'
}

export enum ActivityStatus {
  'Draft' = 'Draft',
  'Auditing' = 'Auditing',
  'Reject' = 'Reject',
  'Approved' = 'Approved',
  'Published' = 'Published'
}

export enum AttachmentHostType {
  'PayrollRequisition' = 'PayrollRequisition',
  'Reimbursement' = 'Reimbursement',
  'Protocol' = 'Protocol',
  'Temp' = 'Temp'
}

export enum AuditFilterType {
  'NotStart' = 'NotStart',
  'Auditing' = 'Auditing',
  'Passed' = 'Passed',
  'Rejected' = 'Rejected'
}

export enum AuditFLowStatus {
  '已关闭' = '已关闭',
  '开放' = '开放'
}

export enum AuditFlowType {
  'AudtitOne' = 'AudtitOne',
  'AuditAll' = 'AuditAll'
}

export enum AuditUserLogStatus {
  'Reject' = 'Reject',
  'Pass' = 'Pass',
  'Back' = 'Back',
  'Continue' = 'Continue'
}

export enum AuditUserLogType {
  'Unknow' = 'Unknow',
  'Project' = 'Project',
  'PayrollRequisition' = 'PayrollRequisition',
  'Reimbursement' = 'Reimbursement',
  'ActivityRefund' = 'ActivityRefund',
  'UserCardRefund' = 'UserCardRefund',
  'UserDiffCardRefund' = 'UserDiffCardRefund',
  'ActivityPublish' = 'ActivityPublish'
}

export enum AuthorizeScope {
  'snapi_base' = 'snapi_base',
  'snsapi_userinfo' = 'snsapi_userinfo'
}

export enum ClientType {
  'System' = 'System',
  'WeixinMini' = 'WeixinMini',
  'Weixin' = 'Weixin',
  'App' = 'App'
}

export enum CmsContentStatus {
  'Draft' = 'Draft',
  'Published' = 'Published'
}

export enum CopyFrom {
  'Headquarters' = 'Headquarters',
  'BigArea' = 'BigArea',
  'PartialArea' = 'PartialArea'
}

export enum CopyFromViewType {
  'Headquarters' = 'Headquarters',
  'PartialArea' = 'PartialArea',
  'BigArea' = 'BigArea',
  'All' = 'All',
  'OnlyMe' = 'OnlyMe'
}

export enum EventTypeEnum {
  'Favorite' = 'Favorite',
  'Share' = 'Share',
  'Zan' = 'Zan'
}

export enum ImportResultType {
  'Inserted' = 'Inserted',
  'Updated' = 'Updated',
  'NotFound' = 'NotFound',
  'ValidationError' = 'ValidationError',
  'Error' = 'Error',
  'DataConvertFailed' = 'DataConvertFailed'
}

export enum ImportTarget {
  'SocialSecurityAssign' = 'SocialSecurityAssign',
  'CommonReserveFundAssign' = 'CommonReserveFundAssign',
  'IncomeStatistics' = 'IncomeStatistics',
  'PayrollOfPartner' = 'PayrollOfPartner',
  'PayrollOfSelf' = 'PayrollOfSelf',
  'PayrollAssign' = 'PayrollAssign',
  'IncomeRecord' = 'IncomeRecord',
  'Salary' = 'Salary',
  'ProjectLedger' = 'ProjectLedger'
}

export enum IncomeSupplementCategory {
  'Activity' = 'Activity',
  'Card' = 'Card'
}

export enum NotificationSeverity {
  'Info' = 'Info',
  'Success' = 'Success',
  'Warn' = 'Warn',
  'Error' = 'Error',
  'Fatal' = 'Fatal'
}

export enum OrganizationLevel {
  'Headquarters' = 'Headquarters',
  'BigArea' = 'BigArea',
  'PartialArea' = 'PartialArea',
  'Store' = 'Store'
}

export enum OrganizationStatus {
  '未审核' = '未审核',
  '已审核' = '已审核'
}

export enum OrganizationUnitLevel {
  '未分配' = '未分配',
  '总部' = '总部',
  '大区' = '大区',
  '片区' = '片区',
  '门店' = '门店'
}

export enum PaymentCategoryScope {
  'Project' = 'Project',
  'Reimbursement' = 'Reimbursement',
  'Salary' = 'Salary',
  'IncomeRecord' = 'IncomeRecord',
  'PayrollRequisition' = 'PayrollRequisition'
}

export enum PayOrderType {
  'Activity' = 'Activity',
  'Card' = 'Card',
  'DiffCard' = 'DiffCard'
}

export enum PayType {
  '微信' = '微信',
  '微信扫码' = '微信扫码',
  '支付宝' = '支付宝',
  '银联' = '银联',
  '用户余额' = '用户余额'
}

export enum ProfitCategory {
  'Income' = 'Income',
  'Cost' = 'Cost'
}

export enum ProfitType {
  'Store' = 'Store',
  'PartialArea' = 'PartialArea',
  'BigArea' = 'BigArea',
  'Headquarters' = 'Headquarters'
}

export enum ProjectPaymentCategory {
  'Proceeds' = 'Proceeds',
  'AllocateFunds' = 'AllocateFunds'
}

export enum ProjectPaymentCycleType {
  'First' = 'First',
  'Interim' = 'Interim',
  'Finally' = 'Finally'
}

export enum ProtocolType {
  'Partner' = 'Partner',
  'Social' = 'Social',
  'Other' = 'Other'
}

export enum ScanType {
  'QR_CODE' = 'QR_CODE',
  'WX_CODE' = 'WX_CODE'
}

export enum SexEnum {
  '保密' = '保密',
  '男' = '男',
  '女' = '女'
}

export enum SocialSecurityMethod {
  'Self' = 'Self',
  'Company' = 'Company',
  'None' = 'None'
}

export enum SplitOrderCycleType {
  'Daily' = 'Daily',
  'Weekly' = 'Weekly',
  'Monthly' = 'Monthly',
  'Period' = 'Period'
}

export enum SplitReceiverType {
  'Store' = 'Store',
  'AllianceBusiness' = 'AllianceBusiness',
  'Platform' = 'Platform'
}

export enum StoreMainType {
  'IndividualBusiness' = 'IndividualBusiness',
  'Company' = 'Company',
  'PrivateNonEnterpriseUnits' = 'PrivateNonEnterpriseUnits'
}

export enum StoreType {
  'TongMengSelf' = 'TongMengSelf',
  'Partnership' = 'Partnership',
  'AllianceBusinessSelf' = 'AllianceBusinessSelf',
  'JointOperation' = 'JointOperation'
}

export enum TenantAvailabilityState {
  'Available' = 'Available',
  'InActive' = 'InActive',
  'NotFound' = 'NotFound'
}

export enum UserActivityApplyStatus {
  'NotApply' = 'NotApply',
  'HasApply' = 'HasApply',
  'NotLogin' = 'NotLogin'
}

export enum UserBuyCardType {
  'New' = 'New',
  'Renew' = 'Renew'
}

export enum UserCardLogType {
  'UnKnow' = 'UnKnow',
  'StartUse' = 'StartUse',
  'Refunding' = 'Refunding',
  'Freeze' = 'Freeze',
  'Enable' = 'Enable',
  'Delay' = 'Delay',
  'Revoke' = 'Revoke',
  'Deduction' = 'Deduction',
  'Canceled' = 'Canceled'
}

export enum UserCardStatus {
  'Refunding' = 'Refunding',
  'Freeze' = 'Freeze',
  'Payed' = 'Payed',
  'Canceled' = 'Canceled'
}

export enum UserNotificationState {
  'Unread' = 'Unread',
  'Read' = 'Read'
}
